export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Date` scalar type represents a date in UTC. */
  Date: { input: string; output: string; }
  /** The `DateTime` scalar type represents a date and time with time zone offset information. */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a decimal floating-point number with high precision. */
  Decimal: { input: number; output: number; }
  /** The `Long` scalar type represents a signed 64-bit integer. */
  Long: { input: number; output: number; }
  /** The `UUID` scalar type represents a Universally Unique Identifier (UUID) as defined by RFC 9562. */
  UUID: { input: string; output: string; }
};

export type Account = AccountCommon & {
  __typename?: 'Account';
  addresses: Array<Address>;
  billToCountries: Array<CountryDetailsDto>;
  companyName: Scalars['String']['output'];
  contacts: Array<User>;
  currency: Currency;
  customerNumber?: Maybe<Scalars['String']['output']>;
  defaultBillToAddress: Address;
  defaultBillToContact: User;
  iamId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  primary: Scalars['Boolean']['output'];
};

/** Fields shared by Account and DealerCustomer. */
export type AccountCommon = {
  companyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export const AccountCommonType = {
  Account: 'ACCOUNT',
  DealerCustomer: 'DEALER_CUSTOMER'
} as const;

export type AccountCommonType = typeof AccountCommonType[keyof typeof AccountCommonType];
export type AccountCommonTypeOperationFilterInput = {
  eq?: InputMaybe<AccountCommonType>;
  in?: InputMaybe<Array<AccountCommonType>>;
  neq?: InputMaybe<AccountCommonType>;
  nin?: InputMaybe<Array<AccountCommonType>>;
};

export type AccountEntitlement = {
  __typename?: 'AccountEntitlement';
  product: Product;
  totalValue: Scalars['Int']['output'];
};

export type AccountFilterInput = {
  and?: InputMaybe<Array<AccountFilterInput>>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AccountFilterInput>>;
};

export type AccountNotificationPreferenceDto = {
  __typename?: 'AccountNotificationPreferenceDTO';
  dealerAccountId: Scalars['String']['output'];
  eligibleRoles: Array<DealerUserRole>;
  ignoreNotification: Scalars['Boolean']['output'];
  isNotificationDisableRestricted: Scalars['Boolean']['output'];
  notificationCategory: NotificationEventCategory;
  notificationCategoryDisplayOrder: Scalars['Int']['output'];
  notificationCategoryId: Scalars['Int']['output'];
  notificationChannel: NotificationChannel;
  notificationEventType: NotificationEvent;
  notificationEventTypeDisplayOrder: Scalars['Int']['output'];
  notificationEventTypeId: Scalars['Int']['output'];
  subCategory?: Maybe<TermUomType>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AddOnBaseValidationResult = {
  __typename?: 'AddOnBaseValidationResult';
  missingBase: Array<SkuWarningItem>;
  removedBase: Array<SkuWarningItem>;
};

export type AddProductLineAmendmentInput = {
  entitlementId?: InputMaybe<Scalars['String']['input']>;
  newProductId: Scalars['ID']['input'];
  productType?: InputMaybe<SkuKind>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AddSeatsLineAmendmentInput = {
  currentProductId: Scalars['ID']['input'];
  entitlementId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<SkuKind>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type Address = {
  __typename?: 'Address';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  countryDetails: CountryDetails;
  id: Scalars['ID']['output'];
  stateDetails?: Maybe<Region>;
  zip: Scalars['String']['output'];
};

export type AddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  stateCode?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

/**
 * Api-layer input for amendment quote mutations.
 * Mirrors AmendmentQuoteInput but lives in the
 * Api project so that ContractIdDescriptorAttribute and
 * QuoteIdDescriptorAttribute can be applied directly to the ID fields,
 * enabling the pre-validation middlewares to locate the IDs via the GraphQL directive
 * rather than by reflected property-name string matching.
 */
export type AmendmentQuoteInput = {
  addProducts?: InputMaybe<Array<AddProductLineAmendmentInput>>;
  addSeats?: InputMaybe<Array<AddSeatsLineAmendmentInput>>;
  amendmentType?: AmendmentType;
  contractId: Scalars['ID']['input'];
  createFromQuoteId?: InputMaybe<Scalars['String']['input']>;
  customerRequestId?: InputMaybe<Scalars['String']['input']>;
  discountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  downgrades?: InputMaybe<Array<DowngradeLineAmendmentInput>>;
  primaryAccountOwnerEmail?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  removeProducts?: InputMaybe<Array<RemoveProductLineAmendmentInput>>;
  removeSeats?: InputMaybe<Array<RemoveSeatsLineAmendmentInput>>;
  repriceActionType?: RepriceActionType;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  upgrades?: InputMaybe<Array<UpgradeLineAmendmentInput>>;
  userComment?: InputMaybe<Scalars['String']['input']>;
};

export const AmendmentType = {
  NegativeOnly: 'NEGATIVE_ONLY',
  PositiveAndNegative: 'POSITIVE_AND_NEGATIVE',
  PositiveOnly: 'POSITIVE_ONLY'
} as const;

export type AmendmentType = typeof AmendmentType[keyof typeof AmendmentType];
/** A connection to a list of items. */
export type AmendmentsConnection = {
  __typename?: 'AmendmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AmendmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Quote>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AmendmentsEdge = {
  __typename?: 'AmendmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Quote;
};

export type AnonymisedOwner = AccountCommon & {
  __typename?: 'AnonymisedOwner';
  companyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ApplicationAuditAdditionalData = ContractAuditAdditionalData | CustomerAuditAdditionalData | DealerAuditAdditionalData | DeviceAuditAdditionalData;

/** Fields shared by every audit log entry. Concrete types narrow additionalData to their event category. */
export type ApplicationAuditLogEntry = {
  accountName?: Maybe<Scalars['String']['output']>;
  additionalData?: Maybe<ApplicationAuditAdditionalData>;
  changeLog?: Maybe<Array<Maybe<AuditLogChangeItem>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  eventCategory: ApplicationLogEventCategory;
  eventGroup: ApplicationLogEventGroup;
  eventType: ApplicationLogEventType;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  performedBy?: Maybe<User>;
  performedByType: PerformedByType;
};

export type ApplicationAuditLogEntryFilterInput = {
  and?: InputMaybe<Array<ApplicationAuditLogEntryFilterInput>>;
  eventCategory?: InputMaybe<ApplicationLogEventCategoryOperationFilterInput>;
  eventGroup?: InputMaybe<ApplicationLogEventGroupOperationFilterInput>;
  eventType?: InputMaybe<ApplicationLogEventTypeOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  occurredAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationAuditLogEntryFilterInput>>;
  performedBy?: InputMaybe<UuidOperationFilterInput>;
  performedByType?: InputMaybe<PerformedByTypeOperationFilterInput>;
};

export type ApplicationAuditLogEntrySortInput = {
  occurredAt?: InputMaybe<SortEnumType>;
};

export const ApplicationLogEventCategory = {
  Contract: 'CONTRACT',
  Customer: 'CUSTOMER',
  Dealer: 'DEALER',
  Device: 'DEVICE'
} as const;

export type ApplicationLogEventCategory = typeof ApplicationLogEventCategory[keyof typeof ApplicationLogEventCategory];
export type ApplicationLogEventCategoryOperationFilterInput = {
  eq?: InputMaybe<ApplicationLogEventCategory>;
  in?: InputMaybe<Array<ApplicationLogEventCategory>>;
  neq?: InputMaybe<ApplicationLogEventCategory>;
  nin?: InputMaybe<Array<ApplicationLogEventCategory>>;
};

export const ApplicationLogEventGroup = {
  AddDevice: 'ADD_DEVICE',
  AmendmentCreated: 'AMENDMENT_CREATED',
  AmendmentDeleted: 'AMENDMENT_DELETED',
  AmendmentDiscount: 'AMENDMENT_DISCOUNT',
  AmendmentExpired: 'AMENDMENT_EXPIRED',
  AmendmentRepriced: 'AMENDMENT_REPRICED',
  AmendmentStatusChange: 'AMENDMENT_STATUS_CHANGE',
  AmendmentUpdated: 'AMENDMENT_UPDATED',
  ContractCancelled: 'CONTRACT_CANCELLED',
  ContractCreated: 'CONTRACT_CREATED',
  ContractDeleted: 'CONTRACT_DELETED',
  ContractDiscount: 'CONTRACT_DISCOUNT',
  ContractExpired: 'CONTRACT_EXPIRED',
  ContractReminder: 'CONTRACT_REMINDER',
  ContractSettingsUpdated: 'CONTRACT_SETTINGS_UPDATED',
  ContractStatusChange: 'CONTRACT_STATUS_CHANGE',
  ContractUpdated: 'CONTRACT_UPDATED',
  CustomerManagement: 'CUSTOMER_MANAGEMENT',
  CustomerNotificationSetting: 'CUSTOMER_NOTIFICATION_SETTING',
  CustomerOrganizationChanged: 'CUSTOMER_ORGANIZATION_CHANGED',
  CustomerRequest: 'CUSTOMER_REQUEST',
  CustomerSettingsUpdated: 'CUSTOMER_SETTINGS_UPDATED',
  CustomerShipToAddressCreated: 'CUSTOMER_SHIP_TO_ADDRESS_CREATED',
  DealerNotificationSettings: 'DEALER_NOTIFICATION_SETTINGS',
  DealerSettingsUpdated: 'DEALER_SETTINGS_UPDATED',
  DeviceStatusChange: 'DEVICE_STATUS_CHANGE',
  DeviceSubscription: 'DEVICE_SUBSCRIPTION',
  DeviceTransfer: 'DEVICE_TRANSFER',
  DeviceUpdated: 'DEVICE_UPDATED',
  EeucForm: 'EEUC_FORM',
  OfflineAutoRevokeUpdated: 'OFFLINE_AUTO_REVOKE_UPDATED',
  OptInRequest: 'OPT_IN_REQUEST',
  OrganizationAssigned: 'ORGANIZATION_ASSIGNED',
  OrganizationCreated: 'ORGANIZATION_CREATED',
  RenewalPlanUpdated: 'RENEWAL_PLAN_UPDATED',
  SuperkeyManagement: 'SUPERKEY_MANAGEMENT',
  UserSubscriptionAssignment: 'USER_SUBSCRIPTION_ASSIGNMENT',
  UserSubscriptionRevocation: 'USER_SUBSCRIPTION_REVOCATION'
} as const;

export type ApplicationLogEventGroup = typeof ApplicationLogEventGroup[keyof typeof ApplicationLogEventGroup];
export type ApplicationLogEventGroupOperationFilterInput = {
  eq?: InputMaybe<ApplicationLogEventGroup>;
  in?: InputMaybe<Array<ApplicationLogEventGroup>>;
  neq?: InputMaybe<ApplicationLogEventGroup>;
  nin?: InputMaybe<Array<ApplicationLogEventGroup>>;
};

export const ApplicationLogEventType = {
  AmendmentActivated: 'AMENDMENT_ACTIVATED',
  AmendmentActivationInProgress: 'AMENDMENT_ACTIVATION_IN_PROGRESS',
  AmendmentCancelled: 'AMENDMENT_CANCELLED',
  AmendmentDiscountApproved: 'AMENDMENT_DISCOUNT_APPROVED',
  AmendmentDiscountRejected: 'AMENDMENT_DISCOUNT_REJECTED',
  AmendmentDiscountRemoved: 'AMENDMENT_DISCOUNT_REMOVED',
  AmendmentDiscountRequested: 'AMENDMENT_DISCOUNT_REQUESTED',
  AmendmentDraftCreated: 'AMENDMENT_DRAFT_CREATED',
  AmendmentDraftDeleted: 'AMENDMENT_DRAFT_DELETED',
  AmendmentDraftExpired: 'AMENDMENT_DRAFT_EXPIRED',
  AmendmentError: 'AMENDMENT_ERROR',
  AmendmentOnHold: 'AMENDMENT_ON_HOLD',
  AmendmentPoNumberUpdated: 'AMENDMENT_PO_NUMBER_UPDATED',
  AmendmentPromocodeApplied: 'AMENDMENT_PROMOCODE_APPLIED',
  AmendmentPromocodeRemoved: 'AMENDMENT_PROMOCODE_REMOVED',
  AmendmentRepriced: 'AMENDMENT_REPRICED',
  AmendmentRepriceRequired: 'AMENDMENT_REPRICE_REQUIRED',
  AmendmentResubmitted: 'AMENDMENT_RESUBMITTED',
  AmendmentSubmitted: 'AMENDMENT_SUBMITTED',
  AutoRenewalUpdated: 'AUTO_RENEWAL_UPDATED',
  AutoRenewUpdatedForCustomer: 'AUTO_RENEW_UPDATED_FOR_CUSTOMER',
  AutoRenewUpdatedForDealer: 'AUTO_RENEW_UPDATED_FOR_DEALER',
  AwaitingApprovalFromAdmin: 'AWAITING_APPROVAL_FROM_ADMIN',
  BillingFrequencyChangesApproved: 'BILLING_FREQUENCY_CHANGES_APPROVED',
  BillingFrequencyChangesDeclined: 'BILLING_FREQUENCY_CHANGES_DECLINED',
  BillingFrequencyChangeRequested: 'BILLING_FREQUENCY_CHANGE_REQUESTED',
  BulkEmailNotificationSettingsUpdated: 'BULK_EMAIL_NOTIFICATION_SETTINGS_UPDATED',
  ContractAccountOwnerActivationReminder: 'CONTRACT_ACCOUNT_OWNER_ACTIVATION_REMINDER',
  ContractActivatedAutomatically: 'CONTRACT_ACTIVATED_AUTOMATICALLY',
  ContractActivatedManually: 'CONTRACT_ACTIVATED_MANUALLY',
  ContractActivationInProgress: 'CONTRACT_ACTIVATION_IN_PROGRESS',
  ContractCancelled: 'CONTRACT_CANCELLED',
  ContractDraftCreated: 'CONTRACT_DRAFT_CREATED',
  ContractDraftDeleted: 'CONTRACT_DRAFT_DELETED',
  ContractDraftEdited: 'CONTRACT_DRAFT_EDITED',
  ContractDraftExpired: 'CONTRACT_DRAFT_EXPIRED',
  ContractEndDateUpdated: 'CONTRACT_END_DATE_UPDATED',
  ContractError: 'CONTRACT_ERROR',
  ContractExpired: 'CONTRACT_EXPIRED',
  ContractMigrated: 'CONTRACT_MIGRATED',
  ContractOnHold: 'CONTRACT_ON_HOLD',
  ContractPendingActivation: 'CONTRACT_PENDING_ACTIVATION',
  ContractPoNumberUpdated: 'CONTRACT_PO_NUMBER_UPDATED',
  ContractRenewalDeleted: 'CONTRACT_RENEWAL_DELETED',
  ContractRenewalDraftCreated: 'CONTRACT_RENEWAL_DRAFT_CREATED',
  ContractRenewalError: 'CONTRACT_RENEWAL_ERROR',
  ContractRenewalExpired: 'CONTRACT_RENEWAL_EXPIRED',
  ContractRenewalInitiated: 'CONTRACT_RENEWAL_INITIATED',
  ContractRenewalSubmitted: 'CONTRACT_RENEWAL_SUBMITTED',
  ContractRenewed: 'CONTRACT_RENEWED',
  ContractSubmitted: 'CONTRACT_SUBMITTED',
  ContractTermuomUpdated: 'CONTRACT_TERMUOM_UPDATED',
  CustomerCreated: 'CUSTOMER_CREATED',
  CustomerDeviceTransferApproved: 'CUSTOMER_DEVICE_TRANSFER_APPROVED',
  CustomerDeviceTransferCancelled: 'CUSTOMER_DEVICE_TRANSFER_CANCELLED',
  CustomerDeviceTransferDeclined: 'CUSTOMER_DEVICE_TRANSFER_DECLINED',
  CustomerDeviceTransferFailed: 'CUSTOMER_DEVICE_TRANSFER_FAILED',
  CustomerDeviceTransferRequested: 'CUSTOMER_DEVICE_TRANSFER_REQUESTED',
  CustomerEmailNotificationSettingsForAccountResetted: 'CUSTOMER_EMAIL_NOTIFICATION_SETTINGS_FOR_ACCOUNT_RESETTED',
  CustomerEmailNotificationSettingsForAccountUpdated: 'CUSTOMER_EMAIL_NOTIFICATION_SETTINGS_FOR_ACCOUNT_UPDATED',
  CustomerEmailNotificationSettingsForCategoryUpdated: 'CUSTOMER_EMAIL_NOTIFICATION_SETTINGS_FOR_CATEGORY_UPDATED',
  CustomerEmailNotificationSettingsForEventUpdated: 'CUSTOMER_EMAIL_NOTIFICATION_SETTINGS_FOR_EVENT_UPDATED',
  CustomerOrganizationChanged: 'CUSTOMER_ORGANIZATION_CHANGED',
  CustomerRequestAccepted: 'CUSTOMER_REQUEST_ACCEPTED',
  CustomerRequestDeclined: 'CUSTOMER_REQUEST_DECLINED',
  CustomerRequestDeleted: 'CUSTOMER_REQUEST_DELETED',
  CustomerRequestExpired: 'CUSTOMER_REQUEST_EXPIRED',
  CustomerRequestReceived: 'CUSTOMER_REQUEST_RECEIVED',
  CustomerRequestUpdated: 'CUSTOMER_REQUEST_UPDATED',
  CustomerShipToAddressCreated: 'CUSTOMER_SHIP_TO_ADDRESS_CREATED',
  CustomerToDealerDeviceTransferRequestApproved: 'CUSTOMER_TO_DEALER_DEVICE_TRANSFER_REQUEST_APPROVED',
  CustomerToDealerDeviceTransferRequestCancelled: 'CUSTOMER_TO_DEALER_DEVICE_TRANSFER_REQUEST_CANCELLED',
  CustomerToDealerDeviceTransferRequestDeclined: 'CUSTOMER_TO_DEALER_DEVICE_TRANSFER_REQUEST_DECLINED',
  CustomerToDealerDeviceTransferRequestExpired: 'CUSTOMER_TO_DEALER_DEVICE_TRANSFER_REQUEST_EXPIRED',
  CustomerToDealerDeviceTransferRequestRequested: 'CUSTOMER_TO_DEALER_DEVICE_TRANSFER_REQUEST_REQUESTED',
  DealerCustomerLinked: 'DEALER_CUSTOMER_LINKED',
  DefaultBillToAddressUpdated: 'DEFAULT_BILL_TO_ADDRESS_UPDATED',
  DefaultBillToContactUpdated: 'DEFAULT_BILL_TO_CONTACT_UPDATED',
  DefaultShipToAddressUpdated: 'DEFAULT_SHIP_TO_ADDRESS_UPDATED',
  DefaultShipToContactUpdated: 'DEFAULT_SHIP_TO_CONTACT_UPDATED',
  DeviceBlocked: 'DEVICE_BLOCKED',
  DeviceDealerReferenceUpdated: 'DEVICE_DEALER_REFERENCE_UPDATED',
  DeviceSubscriptionAssigned: 'DEVICE_SUBSCRIPTION_ASSIGNED',
  DeviceSubscriptionRevoked: 'DEVICE_SUBSCRIPTION_REVOKED',
  DeviceTransferredBackToDealer: 'DEVICE_TRANSFERRED_BACK_TO_DEALER',
  DeviceTransferCancelled: 'DEVICE_TRANSFER_CANCELLED',
  DeviceTransferCompleted: 'DEVICE_TRANSFER_COMPLETED',
  DeviceTransferFailed: 'DEVICE_TRANSFER_FAILED',
  DeviceTransferPending: 'DEVICE_TRANSFER_PENDING',
  DeviceTransferScheduled: 'DEVICE_TRANSFER_SCHEDULED',
  DeviceUnblocked: 'DEVICE_UNBLOCKED',
  DiscountApproved: 'DISCOUNT_APPROVED',
  DiscountRejected: 'DISCOUNT_REJECTED',
  DiscountRemoved: 'DISCOUNT_REMOVED',
  DiscountRequested: 'DISCOUNT_REQUESTED',
  DCountryFormCancelled: 'D_COUNTRY_FORM_CANCELLED',
  DCountryFormSubmitted: 'D_COUNTRY_FORM_SUBMITTED',
  EmailNotificationSettingsForAccountResetted: 'EMAIL_NOTIFICATION_SETTINGS_FOR_ACCOUNT_RESETTED',
  EmailNotificationSettingsForAccountUpdated: 'EMAIL_NOTIFICATION_SETTINGS_FOR_ACCOUNT_UPDATED',
  EmailNotificationSettingsForCategoryUpdated: 'EMAIL_NOTIFICATION_SETTINGS_FOR_CATEGORY_UPDATED',
  EmailNotificationSettingsForEventUpdated: 'EMAIL_NOTIFICATION_SETTINGS_FOR_EVENT_UPDATED',
  InappNotificationSettingsForAccountResetted: 'INAPP_NOTIFICATION_SETTINGS_FOR_ACCOUNT_RESETTED',
  InappNotificationSettingsForAccountUpdated: 'INAPP_NOTIFICATION_SETTINGS_FOR_ACCOUNT_UPDATED',
  InappNotificationSettingsForCategoryUpdated: 'INAPP_NOTIFICATION_SETTINGS_FOR_CATEGORY_UPDATED',
  InappNotificationSettingsForEventUpdated: 'INAPP_NOTIFICATION_SETTINGS_FOR_EVENT_UPDATED',
  NegativeRequestDeleted: 'NEGATIVE_REQUEST_DELETED',
  OfflineAutoRevokeDisabled: 'OFFLINE_AUTO_REVOKE_DISABLED',
  OfflineAutoRevokeEnabled: 'OFFLINE_AUTO_REVOKE_ENABLED',
  OptInApproved: 'OPT_IN_APPROVED',
  OptInDeclined: 'OPT_IN_DECLINED',
  OptInExpired: 'OPT_IN_EXPIRED',
  OptInGranted: 'OPT_IN_GRANTED',
  OptInRequested: 'OPT_IN_REQUESTED',
  OptInRevoked: 'OPT_IN_REVOKED',
  OrganizationAssignedToCustomer: 'ORGANIZATION_ASSIGNED_TO_CUSTOMER',
  OrganizationCreated: 'ORGANIZATION_CREATED',
  PromocodeApplied: 'PROMOCODE_APPLIED',
  PromocodeRemoved: 'PROMOCODE_REMOVED',
  RejectedByAdmin: 'REJECTED_BY_ADMIN',
  ShipToContactBulkOperationCompleted: 'SHIP_TO_CONTACT_BULK_OPERATION_COMPLETED',
  ShipToContactBulkOperationInitiated: 'SHIP_TO_CONTACT_BULK_OPERATION_INITIATED',
  ShipToContactUpdated: 'SHIP_TO_CONTACT_UPDATED',
  SuperkeyCreated: 'SUPERKEY_CREATED',
  SuperkeyRevoked: 'SUPERKEY_REVOKED',
  SuperkeySkusRevoked: 'SUPERKEY_SKUS_REVOKED',
  UserInvitationCancelled: 'USER_INVITATION_CANCELLED',
  UserInvitedToAccount: 'USER_INVITED_TO_ACCOUNT',
  UserRoleUpdated: 'USER_ROLE_UPDATED',
  UserSubscriptionAssigned: 'USER_SUBSCRIPTION_ASSIGNED',
  UserSubscriptionRevoked: 'USER_SUBSCRIPTION_REVOKED',
  WithdrawBillingFrequencyChange: 'WITHDRAW_BILLING_FREQUENCY_CHANGE'
} as const;

export type ApplicationLogEventType = typeof ApplicationLogEventType[keyof typeof ApplicationLogEventType];
/**
 * Reference row for audit filter UI: distinct (category, group) from audit.event_type with display order.
 * Not the same as the ApplicationLogEventType enum on individual log entries.
 */
export type ApplicationLogEventTypeDto = {
  __typename?: 'ApplicationLogEventTypeDTO';
  category: ApplicationLogEventCategory;
  group: ApplicationLogEventGroup;
  sortOrder: Scalars['Int']['output'];
};

export type ApplicationLogEventTypeOperationFilterInput = {
  eq?: InputMaybe<ApplicationLogEventType>;
  in?: InputMaybe<Array<ApplicationLogEventType>>;
  neq?: InputMaybe<ApplicationLogEventType>;
  nin?: InputMaybe<Array<ApplicationLogEventType>>;
};

/** Defines when a policy shall be executed. */
export const ApplyPolicy = {
  /** After the resolver was executed. */
  AfterResolver: 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver: 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation: 'VALIDATION'
} as const;

export type ApplyPolicy = typeof ApplyPolicy[keyof typeof ApplyPolicy];
export const ApprovalRequestType = {
  BillingFrequency: 'BILLING_FREQUENCY',
  Discount: 'DISCOUNT'
} as const;

export type ApprovalRequestType = typeof ApprovalRequestType[keyof typeof ApprovalRequestType];
export type ApprovalRequestTypeOperationFilterInput = {
  eq?: InputMaybe<ApprovalRequestType>;
  in?: InputMaybe<Array<ApprovalRequestType>>;
  neq?: InputMaybe<ApprovalRequestType>;
  nin?: InputMaybe<Array<ApprovalRequestType>>;
};

export const ApprovalStatus = {
  Approved: 'APPROVED',
  Pending: 'PENDING',
  Rejected: 'REJECTED'
} as const;

export type ApprovalStatus = typeof ApprovalStatus[keyof typeof ApprovalStatus];
export const ApprovalWithdrawalType = {
  BillingFrequency: 'BILLING_FREQUENCY',
  Discount: 'DISCOUNT',
  Promocode: 'PROMOCODE'
} as const;

export type ApprovalWithdrawalType = typeof ApprovalWithdrawalType[keyof typeof ApprovalWithdrawalType];
/**
 * Wrapper returned by the assignSubscriptionsToUsers bulk mutation. Contains the
 * post-assignment view of users and contract lines.
 */
export type AssignSubscriptionsToUsersResponse = {
  __typename?: 'AssignSubscriptionsToUsersResponse';
  contractLines: Array<ContractLine>;
  users: Array<User>;
};

export const AttentionCategory = {
  ActivatedContractPendingAssignment: 'ACTIVATED_CONTRACT_PENDING_ASSIGNMENT',
  ContractChangeRequest: 'CONTRACT_CHANGE_REQUEST',
  ExpirationAndRenewal: 'EXPIRATION_AND_RENEWAL',
  IssuesWithOrders: 'ISSUES_WITH_ORDERS',
  IssuesWithTransfer: 'ISSUES_WITH_TRANSFER',
  ScheduledTransfer: 'SCHEDULED_TRANSFER',
  TermsOfServicePending: 'TERMS_OF_SERVICE_PENDING',
  TransferRequest: 'TRANSFER_REQUEST'
} as const;

export type AttentionCategory = typeof AttentionCategory[keyof typeof AttentionCategory];
export type AttentionCategoryOperationFilterInput = {
  eq?: InputMaybe<AttentionCategory>;
  in?: InputMaybe<Array<AttentionCategory>>;
  neq?: InputMaybe<AttentionCategory>;
  nin?: InputMaybe<Array<AttentionCategory>>;
};

export type AttentionEventSortInput = {
  createdDateTime?: InputMaybe<SortEnumType>;
  updatedDateTime?: InputMaybe<SortEnumType>;
};

export const AttentionType = {
  AmendmentCancelled: 'AMENDMENT_CANCELLED',
  AmendmentError: 'AMENDMENT_ERROR',
  AmendmentOnHold: 'AMENDMENT_ON_HOLD',
  ContractActivatedPendingAssignment: 'CONTRACT_ACTIVATED_PENDING_ASSIGNMENT',
  ContractCancelled: 'CONTRACT_CANCELLED',
  ContractError: 'CONTRACT_ERROR',
  ContractExpired: 'CONTRACT_EXPIRED',
  ContractExpiring: 'CONTRACT_EXPIRING',
  ContractOnHold: 'CONTRACT_ON_HOLD',
  ContractTosPending: 'CONTRACT_TOS_PENDING',
  CustomerRequest: 'CUSTOMER_REQUEST',
  DeviceTransferFailed: 'DEVICE_TRANSFER_FAILED',
  DeviceTransferRequestCustomer: 'DEVICE_TRANSFER_REQUEST_CUSTOMER',
  DeviceTransferRequestScheduled: 'DEVICE_TRANSFER_REQUEST_SCHEDULED',
  RenewalInitiationError: 'RENEWAL_INITIATION_ERROR'
} as const;

export type AttentionType = typeof AttentionType[keyof typeof AttentionType];
export type AttentionTypeOperationFilterInput = {
  eq?: InputMaybe<AttentionType>;
  in?: InputMaybe<Array<AttentionType>>;
  neq?: InputMaybe<AttentionType>;
  nin?: InputMaybe<Array<AttentionType>>;
};

/**
 * One item in ChangeLog (JSON array): camelCase fieldName, oldValue, newValue.
 * Values serialize as normal JSON scalars (including null when a value is cleared).
 * Constructor order is fieldName, newValue, oldValue (aligned with Object)).
 */
export type AuditLogChangeItem = {
  __typename?: 'AuditLogChangeItem';
  fieldName: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type AuditLogsConnection = {
  __typename?: 'AuditLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AuditLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ApplicationAuditLogEntry>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AuditLogsEdge = {
  __typename?: 'AuditLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ApplicationAuditLogEntry;
};

export type AutoRenewUpdateNotification = {
  __typename?: 'AutoRenewUpdateNotification';
  autoRenew: Scalars['Boolean']['output'];
  contractId: Scalars['ID']['output'];
  contractNumber: Scalars['String']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
};

export const BillingFrequency = {
  Annual: 'ANNUAL',
  Monthly: 'MONTHLY',
  Upfront: 'UPFRONT'
} as const;

export type BillingFrequency = typeof BillingFrequency[keyof typeof BillingFrequency];
export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkEmailValidationResponse = {
  __typename?: 'BulkEmailValidationResponse';
  results: Array<EmailValidationResponse>;
};

export const BulkOperationStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Processing: 'PROCESSING'
} as const;

export type BulkOperationStatus = typeof BulkOperationStatus[keyof typeof BulkOperationStatus];
export const BulkOperationType = {
  ShipToAddress: 'SHIP_TO_ADDRESS',
  ShipToContact: 'SHIP_TO_CONTACT'
} as const;

export type BulkOperationType = typeof BulkOperationType[keyof typeof BulkOperationType];
export type BulkStatusNotification = {
  __typename?: 'BulkStatusNotification';
  customerName?: Maybe<Scalars['String']['output']>;
  failureCount: Scalars['Int']['output'];
  middlewareStatus?: Maybe<Scalars['String']['output']>;
  operationId: Scalars['ID']['output'];
  operationType: BulkOperationType;
  status: BulkOperationStatus;
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

/** Bundle content for one bundle SKU: the key is the bundle SKU, the value is the list of bundle items. */
export type BundleContentBySku = {
  __typename?: 'BundleContentBySku';
  key: Scalars['String']['output'];
  value: Array<ProductBundle>;
};

export type CancelContractOrAmendmentPayload = {
  __typename?: 'CancelContractOrAmendmentPayload';
  isCancelled: Scalars['Boolean']['output'];
  status: ContractStatusType;
  statusChangeReason: ContractStatusReason;
};

export type CancelledContractAffectedDevice = {
  __typename?: 'CancelledContractAffectedDevice';
  deviceId: Scalars['UUID']['output'];
  isExternal: Scalars['Boolean']['output'];
  modelName?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  partNumber?: Maybe<Scalars['String']['output']>;
  revokedLicenseCount: Scalars['Int']['output'];
  scheduledTransferCancelled: Scalars['Boolean']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type CancelledContractAffectedUser = {
  __typename?: 'CancelledContractAffectedUser';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revokedLicenseCount: Scalars['Int']['output'];
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type ClearAdminCachePayload = {
  __typename?: 'ClearAdminCachePayload';
  cleared: Scalars['Boolean']['output'];
  clearedAt: Scalars['DateTime']['output'];
};

/** A connection to a list of items. */
export type CoTermContractsConnection = {
  __typename?: 'CoTermContractsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CoTermContractsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contract>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CoTermContractsEdge = {
  __typename?: 'CoTermContractsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contract;
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type Contract = {
  __typename?: 'Contract';
  activatedOn?: Maybe<Scalars['DateTime']['output']>;
  addressUpdateStatus?: Maybe<BulkOperationStatus>;
  approvalRequests: Array<ContractApprovalRequest>;
  approvalStatus?: Maybe<ApprovalStatus>;
  autoRenew: Scalars['Boolean']['output'];
  billToAccount: Account;
  billToAccountName?: Maybe<Scalars['String']['output']>;
  billToAddress?: Maybe<Address>;
  billToContact?: Maybe<User>;
  billingFrequency: BillingFrequency;
  contractNumber: Scalars['Int']['output'];
  contractNumberSearch: Scalars['String']['output'];
  contractVersions: Array<ContractVersion>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  createdUserRole?: Maybe<DealerUserRole>;
  creditMemos: Array<CreditMemo>;
  currency: Currency;
  customer?: Maybe<DealerCustomer>;
  customerName: Scalars['String']['output'];
  dealerInvoices: Array<DealerInvoice>;
  errorReason?: Maybe<ErrorReason>;
  fileId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['ID']['output'];
  isAmendable: Scalars['Boolean']['output'];
  isEligibleForRenewal: Scalars['Boolean']['output'];
  isMigrated: Scalars['Boolean']['output'];
  licenseAssignmentStatus: LicenseAssignmentStatus;
  lines: Array<ContractLine>;
  listPriceSubtotal: Scalars['Decimal']['output'];
  negativeRequests: Array<NegativeRequest>;
  netPriceSubtotal: Scalars['Decimal']['output'];
  netPriceTotal: Scalars['Decimal']['output'];
  parentContractId?: Maybe<Scalars['UUID']['output']>;
  pendingAmendment?: Maybe<Quote>;
  positiveRequests: Array<PositiveRequest>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quotes: Array<Quote>;
  renewalContract?: Maybe<Contract>;
  renewalDate?: Maybe<Scalars['Date']['output']>;
  renewalInitiationType?: Maybe<ContractRenewalInitiationType>;
  renewalStatus?: Maybe<ContractRenewalStatus>;
  renewalType?: Maybe<ContractRenewalType>;
  shipToAccount: Account;
  /** @deprecated Use `shipToAccount.id` instead. */
  shipToAccountId: Scalars['ID']['output'];
  shipToAddress?: Maybe<Address>;
  shipToContact?: Maybe<User>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status: ContractStatusType;
  statusChangeReason?: Maybe<ContractStatusReason>;
  taxAmount: Scalars['Decimal']['output'];
  termQuantity: Scalars['Int']['output'];
  termUOM: TermUomType;
  termsAccepted: Scalars['Boolean']['output'];
  type: ContractType;
};


export type ContractContractVersionsArgs = {
  order?: InputMaybe<Array<ContractVersionSortInput>>;
  where?: InputMaybe<ContractVersionFilterInput>;
};


export type ContractNegativeRequestsArgs = {
  order?: InputMaybe<Array<NegativeRequestSortInput>>;
  where?: InputMaybe<NegativeRequestFilterInput>;
};


export type ContractPositiveRequestsArgs = {
  where?: InputMaybe<PositiveRequestFilterInput>;
};

export type ContractApprovalRequest = {
  __typename?: 'ContractApprovalRequest';
  approvalRequestType: ApprovalRequestType;
  approvalStatus?: Maybe<ApprovalStatus>;
  approverComment?: Maybe<Scalars['String']['output']>;
  contract: Contract;
  /** @deprecated Use `contract.id` instead. */
  contractId: Scalars['UUID']['output'];
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isNotificationDismissed: Scalars['Boolean']['output'];
  isRequestWithdrawn: Scalars['Boolean']['output'];
  quote?: Maybe<Quote>;
  /** @deprecated Use the `quote` relationship instead. */
  quoteId?: Maybe<Scalars['Long']['output']>;
  requestedBy?: Maybe<Scalars['UUID']['output']>;
  requestedValue?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['UUID']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  userComment?: Maybe<Scalars['String']['output']>;
};

export type ContractApprovalRequestFilterInput = {
  and?: InputMaybe<Array<ContractApprovalRequestFilterInput>>;
  approvalRequestType?: InputMaybe<ApprovalRequestTypeOperationFilterInput>;
  approvalStatus?: InputMaybe<NullableOfApprovalStatusOperationFilterInput>;
  approverComment?: InputMaybe<StringOperationFilterInput>;
  contract?: InputMaybe<ContractFilterInput>;
  contractId?: InputMaybe<UuidOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isNotificationDismissed?: InputMaybe<BooleanOperationFilterInput>;
  isRequestWithdrawn?: InputMaybe<BooleanOperationFilterInput>;
  metaCreatedDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  metaUpdatedDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ContractApprovalRequestFilterInput>>;
  quote?: InputMaybe<QuoteFilterInput>;
  quoteId?: InputMaybe<LongOperationFilterInput>;
  requestedBy?: InputMaybe<UuidOperationFilterInput>;
  requestedValue?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<UuidOperationFilterInput>;
  userComment?: InputMaybe<StringOperationFilterInput>;
};

export type ContractApprovalStatusNotification = {
  __typename?: 'ContractApprovalStatusNotification';
  amendmentQuoteId?: Maybe<Scalars['ID']['output']>;
  approvalRequestType?: Maybe<ApprovalRequestType>;
  approvalStatus: ApprovalStatus;
  contractId: Scalars['ID']['output'];
  contractNumber: Scalars['String']['output'];
};

export type ContractAuditAdditionalData = {
  __typename?: 'ContractAuditAdditionalData';
  actionType?: Maybe<Scalars['String']['output']>;
  affectedDevices?: Maybe<Array<CancelledContractAffectedDevice>>;
  affectedUsers?: Maybe<Array<CancelledContractAffectedUser>>;
  amendmentPurchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  approverComment?: Maybe<Scalars['String']['output']>;
  billingFrequency?: Maybe<BillingFrequency>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractPurchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  currencyId?: Maybe<Scalars['String']['output']>;
  customerAccountName?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerFeedback?: Maybe<CustomerFeedback>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerRequestId?: Maybe<Scalars['String']['output']>;
  discountPercentage?: Maybe<Scalars['Decimal']['output']>;
  errorReason?: Maybe<ErrorReason>;
  failureCount?: Maybe<Scalars['Int']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  legacySystemReferences?: Maybe<Scalars['String']['output']>;
  netPriceTotal?: Maybe<Scalars['Decimal']['output']>;
  parentContractId?: Maybe<Scalars['String']['output']>;
  parentContractNumber?: Maybe<Scalars['String']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quoteId?: Maybe<Scalars['String']['output']>;
  quoteType?: Maybe<QuoteType>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  renewalContractId?: Maybe<Scalars['UUID']['output']>;
  renewalContractNumber?: Maybe<Scalars['String']['output']>;
  renewalInitiationType?: Maybe<ContractRenewalInitiationType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  statusChangeReason?: Maybe<ContractStatusReason>;
  successCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  userComment?: Maybe<Scalars['String']['output']>;
};

export type ContractAuditLogEntry = ApplicationAuditLogEntry & {
  __typename?: 'ContractAuditLogEntry';
  accountName?: Maybe<Scalars['String']['output']>;
  additionalData?: Maybe<ContractAuditAdditionalData>;
  changeLog?: Maybe<Array<Maybe<AuditLogChangeItem>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  eventCategory: ApplicationLogEventCategory;
  eventGroup: ApplicationLogEventGroup;
  eventType: ApplicationLogEventType;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  performedBy?: Maybe<User>;
  performedByType: PerformedByType;
};

export type ContractFilterInput = {
  activatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ContractFilterInput>>;
  approvalRequests?: InputMaybe<ListFilterInputTypeOfContractApprovalRequestFilterInput>;
  approvalStatus?: InputMaybe<NullableOfApprovalStatusOperationFilterInput>;
  autoRenew?: InputMaybe<BooleanOperationFilterInput>;
  contractNumberSearch?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<UuidOperationFilterInput>;
  createdUserRole?: InputMaybe<NullableOfDealerUserRoleOperationFilterInput>;
  creditMemos?: InputMaybe<ListFilterInputTypeOfCreditMemoFilterInput>;
  customerId?: InputMaybe<StringOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  isMigrated?: InputMaybe<BooleanOperationFilterInput>;
  negativeRequests?: InputMaybe<ListFilterInputTypeOfNegativeRequestFilterInput>;
  netPriceTotal?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ContractFilterInput>>;
  positiveRequests?: InputMaybe<ListFilterInputTypeOfPositiveRequestFilterInput>;
  purchaseOrderNumber?: InputMaybe<StringOperationFilterInput>;
  renewalDate?: InputMaybe<DateTimeOperationFilterInput>;
  shipToContactId?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ContractStatusTypeOperationFilterInput>;
  statusChangeReason?: InputMaybe<NullableOfContractStatusReasonOperationFilterInput>;
  type?: InputMaybe<ContractTypeOperationFilterInput>;
};

export type ContractLine = {
  __typename?: 'ContractLine';
  amendmentBreakdown: Array<ContractLineAmendmentBreakdown>;
  breakdown: Array<ContractLineBreakdown>;
  contract?: Maybe<Contract>;
  devices: Array<DealerDevice>;
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  licenseBreakdown: LicenseBreakdown;
  listPriceTotal: Scalars['Decimal']['output'];
  netPriceTotal: Scalars['Decimal']['output'];
  /** When this line is a package, its component (child) lines; empty otherwise. */
  packageContents: Array<ContractLine>;
  /** When this line is a package child, the parent package product; null otherwise. */
  parentPackage?: Maybe<Product>;
  parentPackageProductId?: Maybe<Scalars['String']['output']>;
  pendingQuoteLine?: Maybe<QuoteLine>;
  product: Product;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  /** Returns up to 3 most recent quote lines related to this product ID */
  recentActivity: Array<QuoteLine>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status: ContractStatusType;
  users: Array<User>;
};

export type ContractLineAmendmentBreakdown = {
  __typename?: 'ContractLineAmendmentBreakdown';
  devices: Array<DealerDevice>;
  id: Scalars['ID']['output'];
  licenseBreakdown: LicenseBreakdown;
  quantity: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  status: ContractStatusType;
  users: Array<User>;
};

export type ContractLineBreakdown = {
  __typename?: 'ContractLineBreakdown';
  dailyNetPricePerSeatWithTax?: Maybe<Scalars['Decimal']['output']>;
  discounts?: Maybe<Array<QuoteDiscount>>;
  effectiveStartDate?: Maybe<Scalars['Date']['output']>;
  licenseBreakdown: LicenseBreakdown;
  listPrice?: Maybe<Scalars['Decimal']['output']>;
  listPriceTotal?: Maybe<Scalars['Decimal']['output']>;
  netPriceTotalWithTax: Scalars['Decimal']['output'];
  quantity: Scalars['Int']['output'];
  quoteId: Scalars['ID']['output'];
  quoteNumber?: Maybe<Scalars['String']['output']>;
  quoteType: QuoteType;
  remainingDays?: Maybe<Scalars['Int']['output']>;
  status: ContractStatusType;
  surchargePercent?: Maybe<Scalars['Decimal']['output']>;
  taxAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type ContractLineOutput = {
  __typename?: 'ContractLineOutput';
  listPriceTotal?: Maybe<Scalars['Decimal']['output']>;
  metric?: Maybe<ProductSkuMetric>;
  netPriceTotal?: Maybe<Scalars['Decimal']['output']>;
  packageBundle: Array<PackageBundleDto>;
  pricingBreakdown: Array<ContractLineBreakdown>;
  productDescription: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  recentActivity: Array<RecentActivityOutput>;
  skuTypeName?: Maybe<Scalars['String']['output']>;
  subscriptionModelType: SubscriptionModelType;
};

export const ContractRenewalInitiationType = {
  Auto: 'AUTO',
  Manual: 'MANUAL'
} as const;

export type ContractRenewalInitiationType = typeof ContractRenewalInitiationType[keyof typeof ContractRenewalInitiationType];
export const ContractRenewalLineType = {
  AddProduct: 'ADD_PRODUCT',
  AddSeats: 'ADD_SEATS',
  FullCancellation: 'FULL_CANCELLATION',
  FullDowngrade: 'FULL_DOWNGRADE',
  FullRenew: 'FULL_RENEW',
  PartialCancellation: 'PARTIAL_CANCELLATION',
  PartialDowngrade: 'PARTIAL_DOWNGRADE',
  PartialRenew: 'PARTIAL_RENEW'
} as const;

export type ContractRenewalLineType = typeof ContractRenewalLineType[keyof typeof ContractRenewalLineType];
export const ContractRenewalStatus = {
  RenewalCompleted: 'RENEWAL_COMPLETED',
  RenewalError: 'RENEWAL_ERROR',
  RenewalInitiated: 'RENEWAL_INITIATED',
  RenewalInProgress: 'RENEWAL_IN_PROGRESS'
} as const;

export type ContractRenewalStatus = typeof ContractRenewalStatus[keyof typeof ContractRenewalStatus];
export const ContractRenewalType = {
  Auto: 'AUTO',
  Early: 'EARLY',
  Late: 'LATE',
  Manual: 'MANUAL',
  Regular: 'REGULAR'
} as const;

export type ContractRenewalType = typeof ContractRenewalType[keyof typeof ContractRenewalType];
export type ContractSortInput = {
  activatedOn?: InputMaybe<SortEnumType>;
  approvalStatus?: InputMaybe<SortEnumType>;
  autoRenew?: InputMaybe<SortEnumType>;
  contractNumber?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  createdUserRole?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isMigrated?: InputMaybe<SortEnumType>;
  netPriceTotal?: InputMaybe<SortEnumType>;
  purchaseOrderNumber?: InputMaybe<SortEnumType>;
  renewalDate?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusChangeReason?: InputMaybe<SortEnumType>;
  termUOM?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type ContractStatusChanged = {
  __typename?: 'ContractStatusChanged';
  billToAccountId: Scalars['String']['output'];
  contract: Contract;
  contractId: Scalars['String']['output'];
  status: ContractStatusType;
};

export type ContractStatusNotification = {
  __typename?: 'ContractStatusNotification';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  amendmentQuoteId?: Maybe<Scalars['ID']['output']>;
  contractEndDate?: Maybe<Scalars['Date']['output']>;
  contractId: Scalars['ID']['output'];
  contractNumber: Scalars['String']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  customerRequestId?: Maybe<Scalars['String']['output']>;
  customerRequestStatus?: Maybe<CustomerRequestStatus>;
  errorReason?: Maybe<ErrorReason>;
  notificationReason: NotificationReason;
  renewalInitiationType?: Maybe<ContractRenewalInitiationType>;
  status: ContractStatusType;
  statusChangeReason?: Maybe<ContractStatusReason>;
};

export const ContractStatusReason = {
  AwaitingApprovalFromAdmin: 'AWAITING_APPROVAL_FROM_ADMIN',
  BadDebt: 'BAD_DEBT',
  BillingFrequencyChangesApproved: 'BILLING_FREQUENCY_CHANGES_APPROVED',
  BillingFrequencyChangesDeclined: 'BILLING_FREQUENCY_CHANGES_DECLINED',
  ComplianceAndCreditHold: 'COMPLIANCE_AND_CREDIT_HOLD',
  ComplianceHold: 'COMPLIANCE_HOLD',
  CreditHold: 'CREDIT_HOLD',
  DiscountApproved: 'DISCOUNT_APPROVED',
  DiscountDeclined: 'DISCOUNT_DECLINED',
  DCountryFormRequestRejected: 'D_COUNTRY_FORM_REQUEST_REJECTED',
  DCountryHold: 'D_COUNTRY_HOLD',
  DCountryHoldCustomer: 'D_COUNTRY_HOLD_CUSTOMER',
  DCountryHoldDealer: 'D_COUNTRY_HOLD_DEALER',
  DCountryHoldDealerAndCustomer: 'D_COUNTRY_HOLD_DEALER_AND_CUSTOMER',
  DCountryHoldFormSubmitted: 'D_COUNTRY_HOLD_FORM_SUBMITTED',
  DCountrySubmittedForBothCustomerDealer: 'D_COUNTRY_SUBMITTED_FOR_BOTH_CUSTOMER_DEALER',
  DCountrySubmittedForCustomer: 'D_COUNTRY_SUBMITTED_FOR_CUSTOMER',
  DCountrySubmittedForCustomerPendingDealer: 'D_COUNTRY_SUBMITTED_FOR_CUSTOMER_PENDING_DEALER',
  DCountrySubmittedForDealer: 'D_COUNTRY_SUBMITTED_FOR_DEALER',
  DCountrySubmittedForDealerPendingCustomer: 'D_COUNTRY_SUBMITTED_FOR_DEALER_PENDING_CUSTOMER',
  InvitationNotAcceptedByAccountOwner: 'INVITATION_NOT_ACCEPTED_BY_ACCOUNT_OWNER',
  ManuallyCancelled: 'MANUALLY_CANCELLED',
  ManualRepriceNeeded: 'MANUAL_REPRICE_NEEDED',
  PriceChange: 'PRICE_CHANGE',
  PriceChangeApprovalRequired: 'PRICE_CHANGE_APPROVAL_REQUIRED',
  PriceChangeApproved: 'PRICE_CHANGE_APPROVED',
  PriceChangeRejected: 'PRICE_CHANGE_REJECTED',
  QuoteAutoCancelledRepriceWindowExpired: 'QUOTE_AUTO_CANCELLED_REPRICE_WINDOW_EXPIRED',
  QuoteAutoCancelledStartEndDateSame: 'QUOTE_AUTO_CANCELLED_START_END_DATE_SAME',
  RejectedByAdmin: 'REJECTED_BY_ADMIN',
  SuspensionHold: 'SUSPENSION_HOLD'
} as const;

export type ContractStatusReason = typeof ContractStatusReason[keyof typeof ContractStatusReason];
export const ContractStatusType = {
  /** Contract is ready for end customer use. */
  Activated: 'ACTIVATED',
  /** Activation process has been initiated; waiting for completion. */
  ActivationInProgress: 'ACTIVATION_IN_PROGRESS',
  /** Amendment is ready for end customer use (not sent from MW as there is a dedicated message). */
  AmendmentActivated: 'AMENDMENT_ACTIVATED',
  /** Amendment Activation process completed but not ready for use until a future date */
  AmendmentActivationAwaitingStartDate: 'AMENDMENT_ACTIVATION_AWAITING_START_DATE',
  /** Amendment Activation process has been initiated; waiting for completion. */
  AmendmentActivationInProgress: 'AMENDMENT_ACTIVATION_IN_PROGRESS',
  /** Amendment pricing made by the reseller. */
  AmendmentDraft: 'AMENDMENT_DRAFT',
  /** Indicates an amendment not an initial quote. */
  AmendmentOnHold: 'AMENDMENT_ON_HOLD',
  /** Amendment requested by the reseller. */
  AmendmentSubmitted: 'AMENDMENT_SUBMITTED',
  /** The contract was not fulfilled. */
  Cancelled: 'CANCELLED',
  /** Contract priced and not yet submitted. */
  Draft: 'DRAFT',
  /** An error has occurred during processing. */
  Error: 'ERROR',
  /** Contract draft has expired before progressing. */
  Expired: 'EXPIRED',
  /** Contract cannot be progressed due to order management hold. */
  OnHold: 'ON_HOLD',
  /** Contract is waiting for end customer activation. */
  PendingActivation: 'PENDING_ACTIVATION',
  /** Contract requested by the reseller. */
  Submitted: 'SUBMITTED'
} as const;

export type ContractStatusType = typeof ContractStatusType[keyof typeof ContractStatusType];
export type ContractStatusTypeOperationFilterInput = {
  eq?: InputMaybe<ContractStatusType>;
  in?: InputMaybe<Array<ContractStatusType>>;
  neq?: InputMaybe<ContractStatusType>;
  nin?: InputMaybe<Array<ContractStatusType>>;
};

export const ContractType = {
  New: 'NEW',
  Renewal: 'RENEWAL',
  Trial: 'TRIAL'
} as const;

export type ContractType = typeof ContractType[keyof typeof ContractType];
export type ContractTypeOperationFilterInput = {
  eq?: InputMaybe<ContractType>;
  in?: InputMaybe<Array<ContractType>>;
  neq?: InputMaybe<ContractType>;
  nin?: InputMaybe<Array<ContractType>>;
};

export type ContractVersion = {
  __typename?: 'ContractVersion';
  contractId: Scalars['UUID']['output'];
  metaCreatedDateTime: Scalars['DateTime']['output'];
  netPriceTotal: Scalars['Decimal']['output'];
  type: QuoteType;
  version: Scalars['Int']['output'];
};

export type ContractVersionFilterInput = {
  and?: InputMaybe<Array<ContractVersionFilterInput>>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ContractVersionFilterInput>>;
  type?: InputMaybe<QuoteTypeOperationFilterInput>;
  version?: InputMaybe<IntOperationFilterInput>;
};

export type ContractVersionOutput = {
  __typename?: 'ContractVersionOutput';
  autoRenew: Scalars['Boolean']['output'];
  contractId: Scalars['UUID']['output'];
  contractLines: Array<ContractLineOutput>;
  contractNumber: Scalars['Int']['output'];
  contractNumberSearch: Scalars['String']['output'];
  currencyId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  listPriceTotal?: Maybe<Scalars['Decimal']['output']>;
  netPriceTotal: Scalars['Decimal']['output'];
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quoteDiscounts: Array<QuoteDiscount>;
  renewalDate?: Maybe<Scalars['Date']['output']>;
  status: ContractStatusType;
  surchargeAmount?: Maybe<Scalars['Decimal']['output']>;
  taxAmount?: Maybe<Scalars['Decimal']['output']>;
  termQuantity: Scalars['Int']['output'];
  termUOM: TermUomType;
  type: ContractType;
  version: Scalars['Int']['output'];
};

export type ContractVersionSortInput = {
  createdDate?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ContractsV2Connection = {
  __typename?: 'ContractsV2Connection';
  /** A list of edges. */
  edges?: Maybe<Array<ContractsV2Edge>>;
  hasUnFilteredResults: Scalars['Boolean']['output'];
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contract>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContractsV2Edge = {
  __typename?: 'ContractsV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contract;
};

export const CountryCode = {
  Ad: 'AD',
  Ae: 'AE',
  Af: 'AF',
  Ag: 'AG',
  Ai: 'AI',
  Al: 'AL',
  Am: 'AM',
  Ao: 'AO',
  Aq: 'AQ',
  Ar: 'AR',
  As: 'AS',
  At: 'AT',
  Au: 'AU',
  Aw: 'AW',
  Ax: 'AX',
  Az: 'AZ',
  Ba: 'BA',
  Bb: 'BB',
  Bd: 'BD',
  Be: 'BE',
  Bf: 'BF',
  Bg: 'BG',
  Bh: 'BH',
  Bi: 'BI',
  Bj: 'BJ',
  Bl: 'BL',
  Bm: 'BM',
  Bn: 'BN',
  Bo: 'BO',
  Bq: 'BQ',
  Br: 'BR',
  Bs: 'BS',
  Bt: 'BT',
  Bv: 'BV',
  Bw: 'BW',
  By: 'BY',
  Bz: 'BZ',
  Ca: 'CA',
  Cc: 'CC',
  Cd: 'CD',
  Cf: 'CF',
  Cg: 'CG',
  Ch: 'CH',
  Ci: 'CI',
  Ck: 'CK',
  Cl: 'CL',
  Cm: 'CM',
  Cn: 'CN',
  Co: 'CO',
  Cr: 'CR',
  Cu: 'CU',
  Cv: 'CV',
  Cw: 'CW',
  Cx: 'CX',
  Cy: 'CY',
  Cz: 'CZ',
  De: 'DE',
  Dj: 'DJ',
  Dk: 'DK',
  Dm: 'DM',
  Do: 'DO',
  Dz: 'DZ',
  Ec: 'EC',
  Ee: 'EE',
  Eg: 'EG',
  Eh: 'EH',
  Er: 'ER',
  Es: 'ES',
  Et: 'ET',
  Fi: 'FI',
  Fj: 'FJ',
  Fk: 'FK',
  Fm: 'FM',
  Fo: 'FO',
  Fr: 'FR',
  Ga: 'GA',
  Gb: 'GB',
  Gd: 'GD',
  Ge: 'GE',
  Gf: 'GF',
  Gg: 'GG',
  Gh: 'GH',
  Gi: 'GI',
  Gl: 'GL',
  Gm: 'GM',
  Gn: 'GN',
  Gp: 'GP',
  Gq: 'GQ',
  Gr: 'GR',
  Gs: 'GS',
  Gt: 'GT',
  Gu: 'GU',
  Gw: 'GW',
  Gy: 'GY',
  Hk: 'HK',
  Hm: 'HM',
  Hn: 'HN',
  Hr: 'HR',
  Ht: 'HT',
  Hu: 'HU',
  Id: 'ID',
  Ie: 'IE',
  Il: 'IL',
  Im: 'IM',
  In: 'IN',
  Io: 'IO',
  Iq: 'IQ',
  Ir: 'IR',
  Is: 'IS',
  It: 'IT',
  Je: 'JE',
  Jm: 'JM',
  Jo: 'JO',
  Jp: 'JP',
  Ke: 'KE',
  Kg: 'KG',
  Kh: 'KH',
  Ki: 'KI',
  Km: 'KM',
  Kn: 'KN',
  Kp: 'KP',
  Kr: 'KR',
  Kw: 'KW',
  Ky: 'KY',
  Kz: 'KZ',
  La: 'LA',
  Lb: 'LB',
  Lc: 'LC',
  Li: 'LI',
  Lk: 'LK',
  Lr: 'LR',
  Ls: 'LS',
  Lt: 'LT',
  Lu: 'LU',
  Lv: 'LV',
  Ly: 'LY',
  Ma: 'MA',
  Mc: 'MC',
  Md: 'MD',
  Me: 'ME',
  Mf: 'MF',
  Mg: 'MG',
  Mh: 'MH',
  Mk: 'MK',
  Ml: 'ML',
  Mm: 'MM',
  Mn: 'MN',
  Mo: 'MO',
  Mp: 'MP',
  Mq: 'MQ',
  Mr: 'MR',
  Ms: 'MS',
  Mt: 'MT',
  Mu: 'MU',
  Mv: 'MV',
  Mw: 'MW',
  Mx: 'MX',
  My: 'MY',
  Mz: 'MZ',
  Na: 'NA',
  Nc: 'NC',
  Ne: 'NE',
  Nf: 'NF',
  Ng: 'NG',
  Ni: 'NI',
  Nl: 'NL',
  No: 'NO',
  Np: 'NP',
  Nr: 'NR',
  Nu: 'NU',
  Nz: 'NZ',
  Om: 'OM',
  Pa: 'PA',
  Pe: 'PE',
  Pf: 'PF',
  Pg: 'PG',
  Ph: 'PH',
  Pk: 'PK',
  Pl: 'PL',
  Pm: 'PM',
  Pn: 'PN',
  Pr: 'PR',
  Ps: 'PS',
  Pt: 'PT',
  Pw: 'PW',
  Py: 'PY',
  Qa: 'QA',
  Re: 'RE',
  Ro: 'RO',
  Rs: 'RS',
  Ru: 'RU',
  Rw: 'RW',
  Sa: 'SA',
  Sb: 'SB',
  Sc: 'SC',
  Sd: 'SD',
  Se: 'SE',
  Sg: 'SG',
  Sh: 'SH',
  Si: 'SI',
  Sj: 'SJ',
  Sk: 'SK',
  Sl: 'SL',
  Sm: 'SM',
  Sn: 'SN',
  So: 'SO',
  Sr: 'SR',
  Ss: 'SS',
  St: 'ST',
  Sv: 'SV',
  Sx: 'SX',
  Sy: 'SY',
  Sz: 'SZ',
  Tc: 'TC',
  Td: 'TD',
  Tf: 'TF',
  Tg: 'TG',
  Th: 'TH',
  Tj: 'TJ',
  Tk: 'TK',
  Tl: 'TL',
  Tm: 'TM',
  Tn: 'TN',
  To: 'TO',
  Tr: 'TR',
  Tt: 'TT',
  Tv: 'TV',
  Tw: 'TW',
  Tz: 'TZ',
  Ua: 'UA',
  Ug: 'UG',
  Um: 'UM',
  Us: 'US',
  Uy: 'UY',
  Uz: 'UZ',
  Va: 'VA',
  Vc: 'VC',
  Ve: 'VE',
  Vg: 'VG',
  Vi: 'VI',
  Vn: 'VN',
  Vu: 'VU',
  Wf: 'WF',
  Ws: 'WS',
  Ye: 'YE',
  Yt: 'YT',
  Za: 'ZA',
  Zm: 'ZM',
  Zw: 'ZW'
} as const;

export type CountryCode = typeof CountryCode[keyof typeof CountryCode];
export type CountryDetails = {
  __typename?: 'CountryDetails';
  code: CountryCode;
  defaultName: Scalars['String']['output'];
  regions: Array<Region>;
};

export type CountryDetailsDto = {
  __typename?: 'CountryDetailsDto';
  code: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CreateBulkOperationResponse = {
  __typename?: 'CreateBulkOperationResponse';
  bulkOperationId: Scalars['ID']['output'];
  status: BulkOperationStatus;
};

export type CreateContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerInput = {
  companyIndustry?: InputMaybe<IndustrySector>;
  companyName: Scalars['String']['input'];
  contact: CreateContactInput;
  language: Language;
  /** The email of the owner of the account. A TID invite will be sent out if the email is not already associated with a TID. */
  ownerEmail: Scalars['String']['input'];
  shipToAddress: AddressInput;
};

export type CreateOrAssignOrganizationAndAddressToCustomerInput = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  customerAddress: AddressInput;
  customerId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  organization: CreateOrAssignOrganizationInput;
};

export type CreateOrAssignOrganizationInput =
  { createOrganizationInput: CreateOrganizationInput; organizationId?: never; }
  |  { createOrganizationInput?: never; organizationId: Scalars['ID']['input']; };

export type CreateOrAssignOrganizationToCustomerInput = {
  customerId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  organization: CreateOrAssignOrganizationInput;
};

export type CreateOrganizationInput = {
  address: AddressInput;
  email?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<IndustrySector>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuoteInput = {
  autoRenew: Scalars['Boolean']['input'];
  billToAccountId: Scalars['ID']['input'];
  billToAddressId: Scalars['ID']['input'];
  billToContactId: Scalars['ID']['input'];
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractType?: InputMaybe<ContractType>;
  currencyCode: Scalars['ID']['input'];
  customerAccountId: Scalars['ID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  quoteLines: Array<CreateQuoteLineInput>;
  repriceActionType?: RepriceActionType;
  /** The Ship To Address ID for the customer. If not provided, a db lookup is used. */
  shipToAddressId?: InputMaybe<Scalars['ID']['input']>;
  /** The Ship To Contact ID for the customer. If not provided, a db lookup is used. */
  shipToContactId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  termQuantity: Scalars['Int']['input'];
  termUOM: TermUomType;
};

export type CreateQuoteLineInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  productId: Scalars['ID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type CreateShipToContactBulkOperationInput = {
  contractIds: Array<Scalars['ID']['input']>;
  oldShipToContactId?: InputMaybe<Scalars['ID']['input']>;
  shipToContactId: Scalars['ID']['input'];
};

export type CreditMemo = {
  __typename?: 'CreditMemo';
  contract?: Maybe<Contract>;
  contractId: Scalars['UUID']['output'];
  createdDate: Scalars['DateTime']['output'];
  creditMemoNumber: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  quoteId?: Maybe<Scalars['String']['output']>;
  totalAmountWithTax?: Maybe<Scalars['Decimal']['output']>;
};

export type CreditMemoFilterInput = {
  and?: InputMaybe<Array<CreditMemoFilterInput>>;
  contract?: InputMaybe<ContractFilterInput>;
  contractId?: InputMaybe<UuidOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  creditMemoNumber?: InputMaybe<StringOperationFilterInput>;
  invoice?: InputMaybe<DealerInvoiceFilterInput>;
  or?: InputMaybe<Array<CreditMemoFilterInput>>;
};

export type CreditMemoSortInput = {
  contract?: InputMaybe<ContractSortInput>;
  createdDate?: InputMaybe<SortEnumType>;
  creditMemoNumber?: InputMaybe<SortEnumType>;
  totalAmountWithTax?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CreditMemosConnection = {
  __typename?: 'CreditMemosConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CreditMemosEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CreditMemo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CreditMemosEdge = {
  __typename?: 'CreditMemosEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CreditMemo;
};

export type Currency = {
  __typename?: 'Currency';
  description: Scalars['String']['output'];
  /** char(3) currency code */
  id: Scalars['ID']['output'];
};

export type CustomerAuditAdditionalData = {
  __typename?: 'CustomerAuditAdditionalData';
  accountRole?: Maybe<UserRole>;
  assignedUserEmail?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractPurchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  customerAccountName?: Maybe<Scalars['String']['output']>;
  customerDetailLink?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  entitlementId?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  iamCustomerId?: Maybe<Scalars['String']['output']>;
  invitationEmail?: Maybe<Scalars['String']['output']>;
  invitationId?: Maybe<Scalars['String']['output']>;
  isPreAssigned?: Maybe<Scalars['Boolean']['output']>;
  licenseId?: Maybe<Scalars['String']['output']>;
  optInStatus?: Maybe<OptInStatus>;
  organizationName?: Maybe<Scalars['String']['output']>;
  previousAccountRole?: Maybe<UserRole>;
  previousOrganizationName?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productSkuDescription?: Maybe<Scalars['String']['output']>;
  shipToAddress?: Maybe<Scalars['String']['output']>;
  updatedAccountRole?: Maybe<UserRole>;
  updatedOrganizationName?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type CustomerAuditLogEntry = ApplicationAuditLogEntry & {
  __typename?: 'CustomerAuditLogEntry';
  accountName?: Maybe<Scalars['String']['output']>;
  additionalData?: Maybe<CustomerAuditAdditionalData>;
  changeLog?: Maybe<Array<Maybe<AuditLogChangeItem>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  eventCategory: ApplicationLogEventCategory;
  eventGroup: ApplicationLogEventGroup;
  eventType: ApplicationLogEventType;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  performedBy?: Maybe<User>;
  performedByType: PerformedByType;
};

export type CustomerDeviceTransferAuditDetails = DeviceAuditDetails & {
  __typename?: 'CustomerDeviceTransferAuditDetails';
  customerAccountName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerRequestId?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  device: DeviceAuditSnapshot;
  transferStatus?: Maybe<CustomerDeviceTransferStatus>;
};

export type CustomerDeviceTransferRequest = {
  __typename?: 'CustomerDeviceTransferRequest';
  createdAt: Scalars['DateTime']['output'];
  customer: DealerCustomer;
  dealer: Account;
  device: DealerDevice;
  id: Scalars['ID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  requestDate: Scalars['DateTime']['output'];
  transferStatus: CustomerDeviceTransferStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type CustomerDeviceTransferRequestFilterInput = {
  and?: InputMaybe<Array<CustomerDeviceTransferRequestFilterInput>>;
  customerCdhAccountId?: InputMaybe<StringOperationFilterInput>;
  customerIamAccountId?: InputMaybe<UuidOperationFilterInput>;
  customerReference?: InputMaybe<StringOperationFilterInput>;
  customerRequestId?: InputMaybe<UuidOperationFilterInput>;
  dealerCdhAccountId?: InputMaybe<StringOperationFilterInput>;
  dealerIamAccountId?: InputMaybe<UuidOperationFilterInput>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  metaCreatedDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  metaUpdatedDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerDeviceTransferRequestFilterInput>>;
  requestDate?: InputMaybe<DateTimeOperationFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  transferStatus?: InputMaybe<CustomerDeviceTransferStatusOperationFilterInput>;
  userUuid?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerDeviceTransferRequestSortInput = {
  transferStatus?: InputMaybe<SortEnumType>;
};

export const CustomerDeviceTransferStatus = {
  Approved: 'APPROVED',
  Cancelled: 'CANCELLED',
  Declined: 'DECLINED',
  Failed: 'FAILED',
  Requested: 'REQUESTED'
} as const;

export type CustomerDeviceTransferStatus = typeof CustomerDeviceTransferStatus[keyof typeof CustomerDeviceTransferStatus];
export type CustomerDeviceTransferStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerDeviceTransferStatus>;
  in?: InputMaybe<Array<CustomerDeviceTransferStatus>>;
  neq?: InputMaybe<CustomerDeviceTransferStatus>;
  nin?: InputMaybe<Array<CustomerDeviceTransferStatus>>;
};

export type CustomerFeedback = {
  __typename?: 'CustomerFeedback';
  additionalComments?: Maybe<Scalars['String']['output']>;
  otherComments?: Maybe<Scalars['String']['output']>;
  reasonCodes?: Maybe<Array<CustomerFeedbackReason>>;
};

export const CustomerFeedbackReason = {
  Competitor: 'COMPETITOR',
  CostTooHigh: 'COST_TOO_HIGH',
  DifficultToUse: 'DIFFICULT_TO_USE',
  NoFeatures: 'NO_FEATURES',
  NoLongerNeed: 'NO_LONGER_NEED',
  PoorExperience: 'POOR_EXPERIENCE',
  RenewManually: 'RENEW_MANUALLY',
  TechnicalIssues: 'TECHNICAL_ISSUES'
} as const;

export type CustomerFeedbackReason = typeof CustomerFeedbackReason[keyof typeof CustomerFeedbackReason];
export const CustomerRequestStatus = {
  Accepted: 'ACCEPTED',
  Declined: 'DECLINED',
  Deleted: 'DELETED',
  Expired: 'EXPIRED',
  Failure: 'FAILURE',
  NegativeDeleted: 'NEGATIVE_DELETED',
  PositiveAccepted: 'POSITIVE_ACCEPTED',
  PositiveDeclined: 'POSITIVE_DECLINED',
  PositiveDeleted: 'POSITIVE_DELETED',
  PositiveExpired: 'POSITIVE_EXPIRED',
  Received: 'RECEIVED',
  Success: 'SUCCESS',
  Updated: 'UPDATED'
} as const;

export type CustomerRequestStatus = typeof CustomerRequestStatus[keyof typeof CustomerRequestStatus];
export type CustomerRequestStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerRequestStatus>;
  in?: InputMaybe<Array<CustomerRequestStatus>>;
  neq?: InputMaybe<CustomerRequestStatus>;
  nin?: InputMaybe<Array<CustomerRequestStatus>>;
};

export type CustomerSubscription = {
  __typename?: 'CustomerSubscription';
  contractLines: Array<ContractLine>;
  licenseBreakdown: LicenseBreakdown;
  product: Product;
};

export type CustomerToDealerDeviceTransferAuditDetails = DeviceAuditDetails & {
  __typename?: 'CustomerToDealerDeviceTransferAuditDetails';
  customerAccountName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  device: DeviceAuditSnapshot;
  requestId?: Maybe<Scalars['String']['output']>;
};

export type CustomerTransferDeviceNotification = {
  __typename?: 'CustomerTransferDeviceNotification';
  customerName?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
};

export type DCountryFormFieldsInput = {
  acceptanceDate?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  commoditiesDescription?: InputMaybe<Scalars['String']['input']>;
  commoditiesQuantity?: InputMaybe<Scalars['String']['input']>;
  commoditiesValue?: InputMaybe<Scalars['String']['input']>;
  consigneeAddress?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  customerAccountId?: InputMaybe<Scalars['String']['input']>;
  customerAccountName?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dealerAccountId?: InputMaybe<Scalars['String']['input']>;
  dispositionCommoditiesConsigneeProducts?: InputMaybe<Scalars['String']['input']>;
  dispositionCommoditiesCountryNamedItem?: InputMaybe<Scalars['String']['input']>;
  dispositionCommoditiesEndUserIdentified?: InputMaybe<Scalars['String']['input']>;
  dispositionCommoditiesInventoryStockOrder?: InputMaybe<Scalars['String']['input']>;
  dispositionCommoditiesOther?: InputMaybe<Scalars['String']['input']>;
  dispositionCommoditiesReExported?: InputMaybe<Scalars['String']['input']>;
  isDispositionCommoditiesAgreed?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderTitle?: InputMaybe<Scalars['String']['input']>;
  purchaserAddress?: InputMaybe<Scalars['String']['input']>;
  purchaserName?: InputMaybe<Scalars['String']['input']>;
  purchaserOrderNumber?: InputMaybe<Scalars['String']['input']>;
};

export const DCountryFormType = {
  Annual: 'ANNUAL',
  Individual: 'INDIVIDUAL'
} as const;

export type DCountryFormType = typeof DCountryFormType[keyof typeof DCountryFormType];
export type DashboardContractWidgetDetails = {
  __typename?: 'DashboardContractWidgetDetails';
  amendmentQuoteId?: Maybe<Scalars['String']['output']>;
  auditLogId?: Maybe<Scalars['UUID']['output']>;
  contractNumber: Scalars['String']['output'];
  contractType?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  customerRequestId?: Maybe<Scalars['String']['output']>;
  errorReason?: Maybe<ErrorReason>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  renewalInitiationType?: Maybe<ContractRenewalInitiationType>;
  status: Scalars['String']['output'];
  statusChangeReason?: Maybe<ContractStatusReason>;
  unassignedLicenseCount?: Maybe<Scalars['Int']['output']>;
};

export type DashboardDeviceWidgetDetails = {
  __typename?: 'DashboardDeviceWidgetDetails';
  customerName: Scalars['String']['output'];
  deviceModel: Scalars['String']['output'];
  partNumber: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DashboardEventData = {
  __typename?: 'DashboardEventData';
  contractData?: Maybe<DashboardContractWidgetDetails>;
  deviceData?: Maybe<DashboardDeviceWidgetDetails>;
};

export type DashboardEventMessage = {
  __typename?: 'DashboardEventMessage';
  dealerAccountId: Scalars['String']['output'];
  module: ApplicationLogEventCategory;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DealerAccountSearchResult = {
  __typename?: 'DealerAccountSearchResult';
  accountName: Scalars['String']['output'];
  address: Scalars['String']['output'];
  cdhId: Scalars['String']['output'];
  iamAccountId: Scalars['String']['output'];
  ownerEmail: Scalars['String']['output'];
};

export type DealerAddDeviceRequest = {
  __typename?: 'DealerAddDeviceRequest';
  createdAt: Scalars['DateTime']['output'];
  dealerNote?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['ID']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  partNumber: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  transferStatus: DealerAddDeviceRequestStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export const DealerAddDeviceRequestStatus = {
  Approved: 'APPROVED',
  Cancelled: 'CANCELLED',
  Declined: 'DECLINED',
  Expired: 'EXPIRED',
  Requested: 'REQUESTED'
} as const;

export type DealerAddDeviceRequestStatus = typeof DealerAddDeviceRequestStatus[keyof typeof DealerAddDeviceRequestStatus];
export type DealerAuditAdditionalData = {
  __typename?: 'DealerAuditAdditionalData';
  bulkOperationId?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  customerAccountId?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  preferenceChanges?: Maybe<Array<NotificationPreferenceChangeAuditItem>>;
  userId?: Maybe<Scalars['UUID']['output']>;
  users?: Maybe<Array<UserAuditItem>>;
};

export type DealerAuditLogEntry = ApplicationAuditLogEntry & {
  __typename?: 'DealerAuditLogEntry';
  accountName?: Maybe<Scalars['String']['output']>;
  additionalData?: Maybe<DealerAuditAdditionalData>;
  changeLog?: Maybe<Array<Maybe<AuditLogChangeItem>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  eventCategory: ApplicationLogEventCategory;
  eventGroup: ApplicationLogEventGroup;
  eventType: ApplicationLogEventType;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  performedBy?: Maybe<User>;
  performedByType: PerformedByType;
};

export type DealerCustomer = AccountCommon & {
  __typename?: 'DealerCustomer';
  addresses: Array<Address>;
  autoRenewEnabled: Scalars['Boolean']['output'];
  companyName: Scalars['String']['output'];
  contacts: Array<User>;
  customerFromVw?: Maybe<Scalars['Boolean']['output']>;
  defaultShipToAddress?: Maybe<Address>;
  defaultShipToContact: User;
  iamId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The opt-in status interpreted from the dealer↔customer relation, when present. */
  optInStatus?: Maybe<OptInStatus>;
  organization?: Maybe<DealerCustomerOrganization>;
  /** Returns the latest in-progress ship-to-contact bulk operation for this customer. */
  shipToContactBulkOperation?: Maybe<ShipToContactBulkDetails>;
  users: Array<UserUnion>;
};


export type DealerCustomerUsersArgs = {
  order?: InputMaybe<Array<DealerCustomerUsersSortInput>>;
  where?: InputMaybe<DealerCustomerUsersFilterInput>;
};

export type DealerCustomerDeviceDto = {
  __typename?: 'DealerCustomerDeviceDTO';
  customerAccountCdhId: Scalars['ID']['output'];
  customerAccountIamId: Scalars['ID']['output'];
  dealerAccountCdhId: Scalars['ID']['output'];
  dealerAccountIamId: Scalars['ID']['output'];
  deviceId: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export type DealerCustomerFilterInput = {
  and?: InputMaybe<Array<DealerCustomerFilterInput>>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DealerCustomerFilterInput>>;
};

export type DealerCustomerOrganization = {
  __typename?: 'DealerCustomerOrganization';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  verified: Scalars['Boolean']['output'];
};

export type DealerCustomerUsersFilterInput = {
  and?: InputMaybe<Array<DealerCustomerUsersFilterInput>>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DealerCustomerUsersFilterInput>>;
  role?: InputMaybe<UserRoleOperationFilterInput>;
  status?: InputMaybe<UserStatusOperationFilterInput>;
};

export type DealerCustomerUsersSortInput = {
  createdAt?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DealerCustomersPagedConnection = {
  __typename?: 'DealerCustomersPagedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DealerCustomersPagedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DealerCustomer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DealerCustomersPagedEdge = {
  __typename?: 'DealerCustomersPagedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DealerCustomer;
};

export type DealerDashboardEvent = {
  __typename?: 'DealerDashboardEvent';
  additionalData?: Maybe<DashboardEventData>;
  createdDateTime: Scalars['DateTime']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<DealerDashboardEventType>;
  id: Scalars['ID']['output'];
  ignoredBy?: Maybe<Scalars['String']['output']>;
  ignoredDate?: Maybe<Scalars['DateTime']['output']>;
  isIgnored: Scalars['Boolean']['output'];
  isResolved: Scalars['Boolean']['output'];
  resolvedBy?: Maybe<Scalars['String']['output']>;
  resolvedDate?: Maybe<Scalars['DateTime']['output']>;
  updatedDateTime?: Maybe<Scalars['DateTime']['output']>;
  validUntilDate?: Maybe<Scalars['Date']['output']>;
};

export type DealerDashboardEventFilterInput = {
  and?: InputMaybe<Array<DealerDashboardEventFilterInput>>;
  category?: InputMaybe<AttentionCategoryOperationFilterInput>;
  module?: InputMaybe<ApplicationLogEventCategoryOperationFilterInput>;
  or?: InputMaybe<Array<DealerDashboardEventFilterInput>>;
  type?: InputMaybe<AttentionTypeOperationFilterInput>;
};

export type DealerDashboardEventType = {
  __typename?: 'DealerDashboardEventType';
  category: AttentionCategory;
  module: ApplicationLogEventCategory;
  order?: Maybe<Scalars['Int']['output']>;
  type: AttentionType;
};

/** A connection to a list of items. */
export type DealerDashboardEventsConnection = {
  __typename?: 'DealerDashboardEventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DealerDashboardEventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DealerDashboardEvent>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DealerDashboardEventsEdge = {
  __typename?: 'DealerDashboardEventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DealerDashboardEvent;
};

export type DealerDashboardFilterInput = {
  and?: InputMaybe<Array<DealerDashboardFilterInput>>;
  createdDateTime?: InputMaybe<DateTimeOperationFilterInput>;
  eventType?: InputMaybe<DealerDashboardEventFilterInput>;
  isIgnored?: InputMaybe<BooleanOperationFilterInput>;
  isResolved?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DealerDashboardFilterInput>>;
};

export type DealerDevice = DealerDeviceCommon & {
  __typename?: 'DealerDevice';
  customerTransferRequest?: Maybe<CustomerDeviceTransferRequest>;
  description?: Maybe<Scalars['String']['output']>;
  desiredDealerCustomer?: Maybe<DealerCustomer>;
  deviceType: DeviceType;
  firmware?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  modelName?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<AccountCommon>;
  ownerName?: Maybe<Scalars['String']['output']>;
  partNumber: Scalars['String']['output'];
  productLines: Array<ProductLineUnion>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  salesOrderNumber?: Maybe<Scalars['Long']['output']>;
  serialNumber: Scalars['String']['output'];
  status?: Maybe<DeviceStatus>;
  superKeyCount: SuperkeyCount;
  superKeyLines: Array<SuperKeyLine>;
  transferDate?: Maybe<Scalars['DateTime']['output']>;
  transferStatus?: Maybe<DeviceTransferStatus>;
};

/** Fields shared by DealerDevice and RequestedDevice. */
export type DealerDeviceCommon = {
  description?: Maybe<Scalars['String']['output']>;
  deviceType: DeviceType;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modelName?: Maybe<Scalars['String']['output']>;
  partNumber: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export type DealerDeviceFilterInput = {
  and?: InputMaybe<Array<DealerDeviceFilterInput>>;
  customerTransferRequest?: InputMaybe<CustomerDeviceTransferRequestFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceType?: InputMaybe<DeviceTypeOperationFilterInput>;
  firmware?: InputMaybe<StringOperationFilterInput>;
  iconUrl?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  modelName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DealerDeviceFilterInput>>;
  owner?: InputMaybe<DealerDeviceOwnerFilterInput>;
  /** @deprecated Use owner: { companyName } instead. */
  ownerName?: InputMaybe<StringOperationFilterInput>;
  partNumber?: InputMaybe<StringOperationFilterInput>;
  purchaseOrderNumber?: InputMaybe<StringOperationFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
  salesOrderNumber?: InputMaybe<LongOperationFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<NullableOfDeviceStatusOperationFilterInput>;
};

export type DealerDeviceOwnerFilterInput = {
  and?: InputMaybe<Array<DealerDeviceOwnerFilterInput>>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DealerDeviceOwnerFilterInput>>;
  typename?: InputMaybe<AccountCommonTypeOperationFilterInput>;
};

export type DealerDeviceOwnerSortInput = {
  companyName?: InputMaybe<SortEnumType>;
};

export type DealerDeviceSortInput = {
  customerTransferRequest?: InputMaybe<CustomerDeviceTransferRequestSortInput>;
  description?: InputMaybe<SortEnumType>;
  deviceType?: InputMaybe<SortEnumType>;
  firmware?: InputMaybe<SortEnumType>;
  iconUrl?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  modelName?: InputMaybe<SortEnumType>;
  owner?: InputMaybe<DealerDeviceOwnerSortInput>;
  ownerName?: InputMaybe<SortEnumType>;
  partNumber?: InputMaybe<SortEnumType>;
  purchaseOrderNumber?: InputMaybe<SortEnumType>;
  reference?: InputMaybe<SortEnumType>;
  salesOrderNumber?: InputMaybe<SortEnumType>;
  serialNumber?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type DealerDeviceTransferNotification = {
  __typename?: 'DealerDeviceTransferNotification';
  deviceId: Scalars['ID']['output'];
  model?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type DealerDevicesConnection = {
  __typename?: 'DealerDevicesConnection';
  deviceSyncState: DeviceSyncState;
  /** A list of edges. */
  edges?: Maybe<Array<DealerDevicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DealerDeviceCommon>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DealerDevicesEdge = {
  __typename?: 'DealerDevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DealerDeviceCommon;
};

export type DealerInvoice = {
  __typename?: 'DealerInvoice';
  balance?: Maybe<Scalars['Decimal']['output']>;
  contract?: Maybe<Contract>;
  /** @deprecated Use `contract.id` instead. */
  contractId: Scalars['UUID']['output'];
  createdDate: Scalars['Date']['output'];
  /** Credit memos associated with this invoice. */
  creditMemos: Array<CreditMemo>;
  downloadUrl: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  lastUpdatedDate: Scalars['DateTime']['output'];
  paymentTerm?: Maybe<Scalars['String']['output']>;
  quoteId: Scalars['String']['output'];
  /** Quote lines from the invoice's linked quote (via external quote id). */
  quoteLines: Array<QuoteLine>;
  totalAmountWithTax?: Maybe<Scalars['Decimal']['output']>;
};

export type DealerInvoiceFilterInput = {
  and?: InputMaybe<Array<DealerInvoiceFilterInput>>;
  balance?: InputMaybe<DecimalOperationFilterInput>;
  contract?: InputMaybe<ContractFilterInput>;
  contractId?: InputMaybe<UuidOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  dueDate?: InputMaybe<DateTimeOperationFilterInput>;
  invoiceNumber?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DealerInvoiceFilterInput>>;
  paymentTerm?: InputMaybe<StringOperationFilterInput>;
  totalAmountWithTax?: InputMaybe<DecimalOperationFilterInput>;
};

export type DealerInvoiceSortInput = {
  balance?: InputMaybe<SortEnumType>;
  contract?: InputMaybe<ContractSortInput>;
  contractId?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  dueDate?: InputMaybe<SortEnumType>;
  paymentTerm?: InputMaybe<SortEnumType>;
  totalAmountWithTax?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DealerInvoicesConnection = {
  __typename?: 'DealerInvoicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DealerInvoicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DealerInvoice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DealerInvoicesEdge = {
  __typename?: 'DealerInvoicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DealerInvoice;
};

/**
 * A strongly-typed dealer permission entry combining a PermissionCategory
 * and PermissionAction.
 *
 * String representation is "Action:Category" (e.g. "view:Contract") used for
 * policy names, claims, and comparisons.
 */
export type DealerPermissionEntry = {
  __typename?: 'DealerPermissionEntry';
  action: PermissionAction;
  category: PermissionCategory;
  /**
   * Returns the "Action:Category" string used for policy names and claims.
   * Uses the C# enum member name (e.g. "CreateAndManage"), matching nameof().
   */
  policy: Scalars['String']['output'];
};

export type DealerUser = {
  __typename?: 'DealerUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastLoginDate?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  permissionList: Array<DealerPermissionEntry>;
  role?: Maybe<DealerUserRole>;
  status: UserStatus;
};

export const DealerUserRole = {
  DealerOwner: 'DEALER_OWNER',
  DealerSecondaryOwner: 'DEALER_SECONDARY_OWNER',
  DealerTechnician: 'DEALER_TECHNICIAN',
  SalesOrderAdmin: 'SALES_ORDER_ADMIN',
  SupportAdmin: 'SUPPORT_ADMIN'
} as const;

export type DealerUserRole = typeof DealerUserRole[keyof typeof DealerUserRole];
export type DealerUserSearchResult = {
  __typename?: 'DealerUserSearchResult';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['UUID']['output'];
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteAmendmentDraftInput = {
  quoteId: Scalars['ID']['input'];
};

export type DeleteAmendmentDraftPayload = {
  __typename?: 'DeleteAmendmentDraftPayload';
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDraftInput = {
  contractId: Scalars['ID']['input'];
};

export type DeleteDraftPayload = {
  __typename?: 'DeleteDraftPayload';
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteNegativeRequestInput = {
  negativeRequestId: Scalars['ID']['input'];
};

export type DeleteNegativeRequestPayload = {
  __typename?: 'DeleteNegativeRequestPayload';
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceAuditAdditionalData = {
  __typename?: 'DeviceAuditAdditionalData';
  comment?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  customerAccountName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerRequestId?: Maybe<Scalars['String']['output']>;
  dealerAddDeviceRequestId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['UUID']['output']>;
  devicePurchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  deviceTransferDate?: Maybe<Scalars['Date']['output']>;
  deviceTransferStatus?: Maybe<DeviceTransferStatus>;
  entitlementId?: Maybe<Scalars['String']['output']>;
  isPreAssigned?: Maybe<Scalars['Boolean']['output']>;
  licenseId?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  partNumber?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  requestorUserId?: Maybe<Scalars['UUID']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  skus?: Maybe<Array<Scalars['String']['output']>>;
  superKeyId?: Maybe<Scalars['String']['output']>;
  timestampUtc?: Maybe<Scalars['String']['output']>;
};

export type DeviceAuditDetails = {
  device: DeviceAuditSnapshot;
};

export type DeviceAuditLogEntry = ApplicationAuditLogEntry & {
  __typename?: 'DeviceAuditLogEntry';
  accountName?: Maybe<Scalars['String']['output']>;
  additionalData?: Maybe<DeviceAuditAdditionalData>;
  changeLog?: Maybe<Array<Maybe<AuditLogChangeItem>>>;
  details?: Maybe<DeviceAuditDetails>;
  entityId?: Maybe<Scalars['String']['output']>;
  eventCategory: ApplicationLogEventCategory;
  eventGroup: ApplicationLogEventGroup;
  eventType: ApplicationLogEventType;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  performedBy?: Maybe<User>;
  performedByType: PerformedByType;
};

export type DeviceAuditSnapshot = {
  __typename?: 'DeviceAuditSnapshot';
  modelName?: Maybe<Scalars['String']['output']>;
  partNumber?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type DeviceExportComplete = {
  __typename?: 'DeviceExportComplete';
  requestId: Scalars['ID']['output'];
};

export type DeviceExportError = {
  __typename?: 'DeviceExportError';
  requestId: Scalars['ID']['output'];
};

export type DeviceExportInput = {
  dealerAccountId: Scalars['ID']['input'];
  exportColumns: Array<ExportColumns>;
  includeSubscriptions: Scalars['Boolean']['input'];
  /** @deprecated Use where: { owner: { typename: { eq: ACCOUNT } }, status: { neq: BLOCKED } } instead. */
  unassignedOnly?: Scalars['Boolean']['input'];
};

export type DeviceExportProgress = {
  __typename?: 'DeviceExportProgress';
  /** Range 0-100 indicating the percentage of completion for the export process */
  progressPercentage: Scalars['Int']['output'];
  requestId: Scalars['ID']['output'];
};

export type DeviceExportUnion = DeviceExportComplete | DeviceExportError | DeviceExportProgress;

export type DeviceModel = {
  __typename?: 'DeviceModel';
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modelName: Scalars['String']['output'];
  partNumber: Scalars['String']['output'];
};

export const DeviceSearchOutcome = {
  Found: 'FOUND',
  NotFound: 'NOT_FOUND',
  OptInRequired: 'OPT_IN_REQUIRED',
  TransferEligible: 'TRANSFER_ELIGIBLE',
  UnableToAdd: 'UNABLE_TO_ADD'
} as const;

export type DeviceSearchOutcome = typeof DeviceSearchOutcome[keyof typeof DeviceSearchOutcome];
export type DeviceSearchResult = {
  __typename?: 'DeviceSearchResult';
  dealerDevice?: Maybe<DealerDevice>;
  outcome: DeviceSearchOutcome;
};

export const DeviceStatus = {
  Active: 'ACTIVE',
  Blocked: 'BLOCKED',
  Unknown: 'UNKNOWN'
} as const;

export type DeviceStatus = typeof DeviceStatus[keyof typeof DeviceStatus];
export type DeviceStatusChangeAuditDetails = DeviceAuditDetails & {
  __typename?: 'DeviceStatusChangeAuditDetails';
  comment?: Maybe<Scalars['String']['output']>;
  customerAccountName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  device: DeviceAuditSnapshot;
  reason?: Maybe<Scalars['String']['output']>;
};

export type DeviceStatusNotification = {
  __typename?: 'DeviceStatusNotification';
  comment?: Maybe<Scalars['String']['output']>;
  customerAccountName?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  partNumber?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DeviceSubscriptionAuditDetails = DeviceAuditDetails & {
  __typename?: 'DeviceSubscriptionAuditDetails';
  contractId?: Maybe<Scalars['String']['output']>;
  customerAccountName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  device: DeviceAuditSnapshot;
  entitlementId?: Maybe<Scalars['String']['output']>;
  isPreAssigned?: Maybe<Scalars['Boolean']['output']>;
  licenseId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
};

export const DeviceSyncState = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  InProgress: 'IN_PROGRESS',
  NotStarted: 'NOT_STARTED'
} as const;

export type DeviceSyncState = typeof DeviceSyncState[keyof typeof DeviceSyncState];
export type DeviceSyncStatus = {
  __typename?: 'DeviceSyncStatus';
  dealerAccountId: Scalars['ID']['output'];
  state: DeviceSyncState;
};

export type DeviceTransferAuditDetails = DeviceAuditDetails & {
  __typename?: 'DeviceTransferAuditDetails';
  customerAccountName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  dealerId?: Maybe<Scalars['String']['output']>;
  device: DeviceAuditSnapshot;
  transferDate?: Maybe<Scalars['Date']['output']>;
  transferStatus?: Maybe<DeviceTransferStatus>;
};

export const DeviceTransferStatus = {
  Approved: 'APPROVED',
  Canceled: 'CANCELED',
  Failed: 'FAILED',
  Pending: 'PENDING',
  Scheduled: 'SCHEDULED'
} as const;

export type DeviceTransferStatus = typeof DeviceTransferStatus[keyof typeof DeviceTransferStatus];
export const DeviceType = {
  Iot: 'IOT',
  NonIot: 'NON_IOT',
  Unknown: 'UNKNOWN'
} as const;

export type DeviceType = typeof DeviceType[keyof typeof DeviceType];
export type DeviceTypeOperationFilterInput = {
  eq?: InputMaybe<DeviceType>;
  in?: InputMaybe<Array<DeviceType>>;
  neq?: InputMaybe<DeviceType>;
  nin?: InputMaybe<Array<DeviceType>>;
};

export type DeviceUpdatedAuditDetails = DeviceAuditDetails & {
  __typename?: 'DeviceUpdatedAuditDetails';
  device: DeviceAuditSnapshot;
};

export const DiscountType = {
  Discretionary: 'DISCRETIONARY',
  Kpi: 'KPI',
  Promo: 'PROMO',
  Standard: 'STANDARD',
  UpgradeCredit: 'UPGRADE_CREDIT',
  UpgradeDebit: 'UPGRADE_DEBIT',
  Volume: 'VOLUME'
} as const;

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];
export type DismissApprovalRequestInput = {
  contractId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
};

export type DowngradeLineAmendmentInput = {
  currentProductId: Scalars['ID']['input'];
  entitlementId?: InputMaybe<Scalars['String']['input']>;
  newProductId: Scalars['ID']['input'];
  productType?: InputMaybe<SkuKind>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type EditRenewalQuoteInput = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  discountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  oldContractId: Scalars['ID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quoteId: Scalars['ID']['input'];
  quoteLines: Array<EditRenewalQuoteLineInput>;
  sfRecordId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  termQuantity?: InputMaybe<Scalars['Int']['input']>;
  termUOM?: InputMaybe<TermUomType>;
  userComment?: InputMaybe<Scalars['String']['input']>;
};

export type EditRenewalQuoteLineDetailInput = {
  lineNumber: Scalars['String']['input'];
  productSku: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type EditRenewalQuoteLineInput = {
  lineNumber?: InputMaybe<Scalars['String']['input']>;
  productSku: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  quoteLineDetails?: InputMaybe<Array<EditRenewalQuoteLineDetailInput>>;
  sfRecordId?: InputMaybe<Scalars['String']['input']>;
};

export const EmailValidationErrorCodes = {
  AlreadyLicenseAdmin: 'ALREADY_LICENSE_ADMIN',
  AlreadyOwner: 'ALREADY_OWNER',
  AlreadyProductUser: 'ALREADY_PRODUCT_USER',
  AlreadySecondary: 'ALREADY_SECONDARY',
  InvalidFormat: 'INVALID_FORMAT',
  SameDomain: 'SAME_DOMAIN',
  Unknown: 'UNKNOWN'
} as const;

export type EmailValidationErrorCodes = typeof EmailValidationErrorCodes[keyof typeof EmailValidationErrorCodes];
export type EmailValidationResponse = {
  __typename?: 'EmailValidationResponse';
  email: Scalars['String']['output'];
  errorCode?: Maybe<EmailValidationErrorCodes>;
  isValid: Scalars['Boolean']['output'];
};

export const ErrorReason = {
  AmendmentInProgress: 'AMENDMENT_IN_PROGRESS',
  ContractOnSuspensionHold: 'CONTRACT_ON_SUSPENSION_HOLD',
  QuoteCreationFailed: 'QUOTE_CREATION_FAILED',
  QuoteCreationIsNotAllowed: 'QUOTE_CREATION_IS_NOT_ALLOWED'
} as const;

export type ErrorReason = typeof ErrorReason[keyof typeof ErrorReason];
export type EventIgnoreItemInput = {
  eventTypeId: Scalars['Int']['input'];
  ignoreNotification: Scalars['Boolean']['input'];
};

export const ExportColumns = {
  Firmware: 'FIRMWARE',
  IsExternalDealer: 'IS_EXTERNAL_DEALER',
  ModelName: 'MODEL_NAME',
  Owner: 'OWNER',
  PartNumber: 'PART_NUMBER',
  PoNumber: 'PO_NUMBER',
  Reference: 'REFERENCE',
  ScheduledTransferDate: 'SCHEDULED_TRANSFER_DATE',
  SerialNumber: 'SERIAL_NUMBER',
  SoNumber: 'SO_NUMBER',
  SubscriptionCount: 'SUBSCRIPTION_COUNT'
} as const;

export type ExportColumns = typeof ExportColumns[keyof typeof ExportColumns];
export type ExportDeviceResponse = {
  __typename?: 'ExportDeviceResponse';
  requestId: Scalars['ID']['output'];
};

export type ExternalContractLine = {
  __typename?: 'ExternalContractLine';
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  product: Product;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type IamAccountSummary = {
  __typename?: 'IAMAccountSummary';
  cdhId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export const IndustrySector = {
  Agriculture: 'AGRICULTURE',
  ArchitectureCommercial: 'ARCHITECTURE_COMMERCIAL',
  ArchitectureLandscape: 'ARCHITECTURE_LANDSCAPE',
  ArchitectureResidential: 'ARCHITECTURE_RESIDENTIAL',
  Banking: 'BANKING',
  Biotechnology: 'BIOTECHNOLOGY',
  BuildingConstructionNonresidential: 'BUILDING_CONSTRUCTION_NONRESIDENTIAL',
  BuildingConstructionResidential: 'BUILDING_CONSTRUCTION_RESIDENTIAL',
  BuildingFinishingDrywallAndInsulationContractors: 'BUILDING_FINISHING_DRYWALL_AND_INSULATION_CONTRACTORS',
  BuildingFinishingFlooring: 'BUILDING_FINISHING_FLOORING',
  BuildingFinishingFlooringContractors: 'BUILDING_FINISHING_FLOORING_CONTRACTORS',
  BuildingFinishingPaintingAndWallCoveringContractors: 'BUILDING_FINISHING_PAINTING_AND_WALL_COVERING_CONTRACTORS',
  BuildingFinishingScaffolding: 'BUILDING_FINISHING_SCAFFOLDING',
  CarrierExemptForHire: 'CARRIER_EXEMPT_FOR_HIRE',
  CarrierForHire: 'CARRIER_FOR_HIRE',
  CarrierPrivateFleet: 'CARRIER_PRIVATE_FLEET',
  CivilConstruction: 'CIVIL_CONSTRUCTION',
  CivilConstructionLandSubdivision: 'CIVIL_CONSTRUCTION_LAND_SUBDIVISION',
  CivilConstructionMarine: 'CIVIL_CONSTRUCTION_MARINE',
  CivilConstructionRoadAndBridge: 'CIVIL_CONSTRUCTION_ROAD_AND_BRIDGE',
  CivilConstructionUrbanPlanning: 'CIVIL_CONSTRUCTION_URBAN_PLANNING',
  CivilConstructionUtilitySystem: 'CIVIL_CONSTRUCTION_UTILITY_SYSTEM',
  Consulting: 'CONSULTING',
  ConsultingAec: 'CONSULTING_AEC',
  ConsultingManagement: 'CONSULTING_MANAGEMENT',
  ConsultingTechnical: 'CONSULTING_TECHNICAL',
  EducationCollegesUniversitiesAndProfessionalSchools: 'EDUCATION_COLLEGES_UNIVERSITIES_AND_PROFESSIONAL_SCHOOLS',
  EducationPrimaryAndSecondarySchools: 'EDUCATION_PRIMARY_AND_SECONDARY_SCHOOLS',
  EducationTechnicalAndTradeSchools: 'EDUCATION_TECHNICAL_AND_TRADE_SCHOOLS',
  Engineering: 'ENGINEERING',
  EngineeringCivil: 'ENGINEERING_CIVIL',
  EngineeringConstructionManagement: 'ENGINEERING_CONSTRUCTION_MANAGEMENT',
  EngineeringElectrical: 'ENGINEERING_ELECTRICAL',
  EngineeringEnvironmental: 'ENGINEERING_ENVIRONMENTAL',
  EngineeringMechanical: 'ENGINEERING_MECHANICAL',
  EngineeringStructural: 'ENGINEERING_STRUCTURAL',
  EntertainmentEventPlanning: 'ENTERTAINMENT_EVENT_PLANNING',
  EntertainmentFilmStage: 'ENTERTAINMENT_FILM_STAGE',
  FabricationMultiTradeMep: 'FABRICATION_MULTI_TRADE_MEP',
  FabricationPiping: 'FABRICATION_PIPING',
  FabricationPrecast: 'FABRICATION_PRECAST',
  FabricationPrecastDetailing: 'FABRICATION_PRECAST_DETAILING',
  FabricationRebar: 'FABRICATION_REBAR',
  FabricationRebarDetailing: 'FABRICATION_REBAR_DETAILING',
  FabricationSheetMetal: 'FABRICATION_SHEET_METAL',
  FabricationSteel: 'FABRICATION_STEEL',
  FabricationSteelDetailing: 'FABRICATION_STEEL_DETAILING',
  FacilitiesManagement: 'FACILITIES_MANAGEMENT',
  FinancialServices: 'FINANCIAL_SERVICES',
  FoodAndBeverageAlcoholicDrinks: 'FOOD_AND_BEVERAGE_ALCOHOLIC_DRINKS',
  FoodAndBeverageDistributors: 'FOOD_AND_BEVERAGE_DISTRIBUTORS',
  FoodAndBeverageHypermarketsSuperCenters: 'FOOD_AND_BEVERAGE_HYPERMARKETS_SUPER_CENTERS',
  FoodAndBeveragePackagedFoodsMeats: 'FOOD_AND_BEVERAGE_PACKAGED_FOODS_MEATS',
  FoodAndBeverageSoftDrinks: 'FOOD_AND_BEVERAGE_SOFT_DRINKS',
  GameDesign: 'GAME_DESIGN',
  GeophysicalServices: 'GEOPHYSICAL_SERVICES',
  GovernmentLocal: 'GOVERNMENT_LOCAL',
  GovernmentNationalFederal: 'GOVERNMENT_NATIONAL_FEDERAL',
  GovernmentStateProvince: 'GOVERNMENT_STATE_PROVINCE',
  HealthcareAndBiotech: 'HEALTHCARE_AND_BIOTECH',
  HomeImprovementDiy: 'HOME_IMPROVEMENT_DIY',
  Hospitality: 'HOSPITALITY',
  Insurance: 'INSURANCE',
  InteriorDesignCommercial: 'INTERIOR_DESIGN_COMMERCIAL',
  InteriorDesignResidential: 'INTERIOR_DESIGN_RESIDENTIAL',
  LegalServices: 'LEGAL_SERVICES',
  LogisticServiceProviderAirHaulage: 'LOGISTIC_SERVICE_PROVIDER_AIR_HAULAGE',
  LogisticServiceProviderCourier: 'LOGISTIC_SERVICE_PROVIDER_COURIER',
  LogisticServiceProviderExpressDelivery: 'LOGISTIC_SERVICE_PROVIDER_EXPRESS_DELIVERY',
  LogisticServiceProviderFoodDelivery: 'LOGISTIC_SERVICE_PROVIDER_FOOD_DELIVERY',
  LogisticServiceProviderFreightHaulage: 'LOGISTIC_SERVICE_PROVIDER_FREIGHT_HAULAGE',
  LogisticServiceProviderPostalServices: 'LOGISTIC_SERVICE_PROVIDER_POSTAL_SERVICES',
  LogisticServiceProviderRailHaulage: 'LOGISTIC_SERVICE_PROVIDER_RAIL_HAULAGE',
  LogisticServiceProviderRoadHaulage: 'LOGISTIC_SERVICE_PROVIDER_ROAD_HAULAGE',
  LogisticServiceProviderStorageAndWarehousing: 'LOGISTIC_SERVICE_PROVIDER_STORAGE_AND_WAREHOUSING',
  LogisticServiceProviderTrucking: 'LOGISTIC_SERVICE_PROVIDER_TRUCKING',
  Manufacturing: 'MANUFACTURING',
  ManufacturingAerospace: 'MANUFACTURING_AEROSPACE',
  ManufacturingBuildingProduct: 'MANUFACTURING_BUILDING_PRODUCT',
  ManufacturingElectrical: 'MANUFACTURING_ELECTRICAL',
  ManufacturingFood: 'MANUFACTURING_FOOD',
  ManufacturingHvac: 'MANUFACTURING_HVAC',
  ManufacturingMechanical: 'MANUFACTURING_MECHANICAL',
  ManufacturingPharmaceuticalMedicine: 'MANUFACTURING_PHARMACEUTICAL_MEDICINE',
  ManufacturingPlumbing: 'MANUFACTURING_PLUMBING',
  ManufacturingSteelProduct: 'MANUFACTURING_STEEL_PRODUCT',
  MaterialsBuilding: 'MATERIALS_BUILDING',
  MepElectricalContractor: 'MEP_ELECTRICAL_CONTRACTOR',
  MepElectricalEngineering: 'MEP_ELECTRICAL_ENGINEERING',
  MepHvacContractor: 'MEP_HVAC_CONTRACTOR',
  MepIctContractor: 'MEP_ICT_CONTRACTOR',
  MepInstrumentalsAndControlsContractor: 'MEP_INSTRUMENTALS_AND_CONTROLS_CONTRACTOR',
  MepMechanicalContractor: 'MEP_MECHANICAL_CONTRACTOR',
  MepMechanicalEngineering: 'MEP_MECHANICAL_ENGINEERING',
  MepMultiTradeMepContractor: 'MEP_MULTI_TRADE_MEP_CONTRACTOR',
  MepPlumbingContractor: 'MEP_PLUMBING_CONTRACTOR',
  MiningAndAggregates: 'MINING_AND_AGGREGATES',
  NonAssetBased_3Pl: 'NON_ASSET_BASED_3PL',
  NonProfitOrganizations: 'NON_PROFIT_ORGANIZATIONS',
  PackingAndLabelingServicesMetalGlassContainers: 'PACKING_AND_LABELING_SERVICES_METAL_GLASS_CONTAINERS',
  PackingAndLabelingServicesPaperPackaging: 'PACKING_AND_LABELING_SERVICES_PAPER_PACKAGING',
  Pharmaceutical: 'PHARMACEUTICAL',
  Private: 'PRIVATE',
  PublicAdministrationDefense: 'PUBLIC_ADMINISTRATION_DEFENSE',
  PublicAdministrationLawEnforcementSecurity: 'PUBLIC_ADMINISTRATION_LAW_ENFORCEMENT_SECURITY',
  RealEstate: 'REAL_ESTATE',
  RetailBrickMortar: 'RETAIL_BRICK_MORTAR',
  RetailEtailor: 'RETAIL_ETAILOR',
  StructureAndFoundationConstructionConcreteContractor: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_CONCRETE_CONTRACTOR',
  StructureAndFoundationConstructionGeneralContractor: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_GENERAL_CONTRACTOR',
  StructureAndFoundationConstructionIndustrial: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_INDUSTRIAL',
  StructureAndFoundationConstructionInfrastructure: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_INFRASTRUCTURE',
  StructureAndFoundationConstructionPrecastDetailing: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_PRECAST_DETAILING',
  StructureAndFoundationConstructionRebarDetailing: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_REBAR_DETAILING',
  StructureAndFoundationConstructionSpecialistContractor: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_SPECIALIST_CONTRACTOR',
  StructureAndFoundationConstructionSteelDetailing: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_STEEL_DETAILING',
  StructureAndFoundationConstructionStructuralSteelContractor: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_STRUCTURAL_STEEL_CONTRACTOR',
  StructureAndFoundationConstructionTemporaryWorks: 'STRUCTURE_AND_FOUNDATION_CONSTRUCTION_TEMPORARY_WORKS',
  SurveyingAndMappingCadastralSurveying: 'SURVEYING_AND_MAPPING_CADASTRAL_SURVEYING',
  SurveyingAndMappingCartographicSurveying: 'SURVEYING_AND_MAPPING_CARTOGRAPHIC_SURVEYING',
  SurveyingAndMappingConstructionSurveying: 'SURVEYING_AND_MAPPING_CONSTRUCTION_SURVEYING',
  SurveyingAndMappingForensics: 'SURVEYING_AND_MAPPING_FORENSICS',
  SurveyingAndMappingGeophysicalSurveying: 'SURVEYING_AND_MAPPING_GEOPHYSICAL_SURVEYING',
  SurveyingAndMappingMappingAndGis: 'SURVEYING_AND_MAPPING_MAPPING_AND_GIS',
  SurveyingAndMappingPhotogrammetry: 'SURVEYING_AND_MAPPING_PHOTOGRAMMETRY',
  SurveyingAndMappingTopographicSurveying: 'SURVEYING_AND_MAPPING_TOPOGRAPHIC_SURVEYING',
  Telecommunications: 'TELECOMMUNICATIONS',
  TransportationAirline: 'TRANSPORTATION_AIRLINE',
  TransportationBulkMaterialsLogistics: 'TRANSPORTATION_BULK_MATERIALS_LOGISTICS',
  TransportationFleetManagement: 'TRANSPORTATION_FLEET_MANAGEMENT',
  TransportationRailroad: 'TRANSPORTATION_RAILROAD',
  TransportationRailTransportation: 'TRANSPORTATION_RAIL_TRANSPORTATION',
  TransportationReadyMix: 'TRANSPORTATION_READY_MIX',
  TransportationStorage: 'TRANSPORTATION_STORAGE',
  TransportationTrucking: 'TRANSPORTATION_TRUCKING',
  UtilitiesCommunicationNetworks: 'UTILITIES_COMMUNICATION_NETWORKS',
  UtilitiesElectricPower: 'UTILITIES_ELECTRIC_POWER',
  UtilitiesEnergy: 'UTILITIES_ENERGY',
  UtilitiesHeatingAndGas: 'UTILITIES_HEATING_AND_GAS',
  UtilitiesOilAndGas: 'UTILITIES_OIL_AND_GAS',
  UtilitiesWasteManagementAndRecycling: 'UTILITIES_WASTE_MANAGEMENT_AND_RECYCLING',
  UtilitiesWaterAndSewage: 'UTILITIES_WATER_AND_SEWAGE',
  WholesaleAndDistribution: 'WHOLESALE_AND_DISTRIBUTION',
  WholesaleElectrical: 'WHOLESALE_ELECTRICAL',
  WholesaleHvac: 'WHOLESALE_HVAC',
  WholesaleMechanical: 'WHOLESALE_MECHANICAL',
  WholesalePlumbing: 'WHOLESALE_PLUMBING',
  Woodworking: 'WOODWORKING'
} as const;

export type IndustrySector = typeof IndustrySector[keyof typeof IndustrySector];
export type IndustrySectorDetails = {
  __typename?: 'IndustrySectorDetails';
  code: IndustrySector;
  defaultName: Scalars['String']['output'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export const Language = {
  Da: 'DA',
  De: 'DE',
  EnUk: 'EN_UK',
  EnUs: 'EN_US',
  EsEs: 'ES_ES',
  Fi: 'FI',
  Fr: 'FR',
  It: 'IT',
  Ja: 'JA',
  Ko: 'KO',
  Nl: 'NL',
  No: 'NO',
  PtBr: 'PT_BR',
  PtPt: 'PT_PT',
  Ru: 'RU',
  Sv: 'SV',
  ZhCh: 'ZH_CH',
  ZhTw: 'ZH_TW'
} as const;

export type Language = typeof Language[keyof typeof Language];
export type LanguageDetail = {
  __typename?: 'LanguageDetail';
  code: Scalars['String']['output'];
  defaultName: Scalars['String']['output'];
  id: Language;
};

export type License = {
  __typename?: 'License';
  holderId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type LicenseAssignmentStatus = {
  __typename?: 'LicenseAssignmentStatus';
  blockedReason: LicenseBlockReason;
  isBlocked: Scalars['Boolean']['output'];
};

export const LicenseBlockReason = {
  AmendmentInProgress: 'AMENDMENT_IN_PROGRESS',
  CustomerAmendmentRequestPending: 'CUSTOMER_AMENDMENT_REQUEST_PENDING',
  NegativeRequestPending: 'NEGATIVE_REQUEST_PENDING',
  None: 'NONE',
  RenewalInProgress: 'RENEWAL_IN_PROGRESS'
} as const;

export type LicenseBlockReason = typeof LicenseBlockReason[keyof typeof LicenseBlockReason];
export type LicenseBreakdown = {
  __typename?: 'LicenseBreakdown';
  assignedSeats: Scalars['Int']['output'];
  licenses: Array<LicenseUnion>;
  unassignedSeats: Scalars['Int']['output'];
};

export type LicenseSelectionInput = {
  assignedCount: Scalars['Int']['input'];
  quoteId: Scalars['ID']['input'];
  unassignedCount: Scalars['Int']['input'];
};

export const LicenseSelectionType = {
  Manual: 'MANUAL',
  Random: 'RANDOM'
} as const;

export type LicenseSelectionType = typeof LicenseSelectionType[keyof typeof LicenseSelectionType];
export type LicenseUnion = License | OfflineLicense;

export type ListFilterInputTypeOfContractApprovalRequestFilterInput = {
  all?: InputMaybe<ContractApprovalRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContractApprovalRequestFilterInput>;
  some?: InputMaybe<ContractApprovalRequestFilterInput>;
};

export type ListFilterInputTypeOfCreditMemoFilterInput = {
  all?: InputMaybe<CreditMemoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CreditMemoFilterInput>;
  some?: InputMaybe<CreditMemoFilterInput>;
};

export type ListFilterInputTypeOfNegativeRequestFilterInput = {
  all?: InputMaybe<NegativeRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<NegativeRequestFilterInput>;
  some?: InputMaybe<NegativeRequestFilterInput>;
};

export type ListFilterInputTypeOfPositiveRequestFilterInput = {
  all?: InputMaybe<PositiveRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PositiveRequestFilterInput>;
  some?: InputMaybe<PositiveRequestFilterInput>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type LookupLists = {
  __typename?: 'LookupLists';
  countries: Array<CountryDetails>;
  industries: Array<IndustrySectorDetails>;
  languages: Array<LanguageDetail>;
};

export type MarkAmendmentCancelledQuoteAsProcessedInput = {
  quoteId: Scalars['ID']['input'];
};

export type MarkAmendmentCancelledQuoteAsProcessedPayload = {
  __typename?: 'MarkAmendmentCancelledQuoteAsProcessedPayload';
  isCancellationProcessed?: Maybe<Scalars['Boolean']['output']>;
};

export type MarkAsReadPayload = {
  __typename?: 'MarkAsReadPayload';
  hasUnReadNotifications: Scalars['Boolean']['output'];
  notification: Notification;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add additional SKUs to an existing superkey on a dealer-owned device */
  addSkusToSuperkey: DealerDevice;
  alignEndDateAndRepriceRenewalContract: Contract;
  approveAndResubmitPricing: Contract;
  /** Approve transfer request of a device */
  approveTransferRequest: DealerDevice;
  /** Assign one or more devices to a subscription */
  assignDevicesToSubscription: ContractLine;
  /** Assign one or more subscriptions to one or more devices */
  assignSubscriptionsToDevices: Array<DealerDevice>;
  /** Assign one or more subscriptions to one or more users. Returns the post-assignment users and contract lines */
  assignSubscriptionsToUsers: AssignSubscriptionsToUsersResponse;
  cancelAmendment: CancelContractOrAmendmentPayload;
  cancelContract: CancelContractOrAmendmentPayload;
  /** Cancel a pending dealer-initiated device add request */
  cancelCustomerToDealerDeviceTransferRequest: DealerAddDeviceRequest;
  cancelInvitation: DealerCustomer;
  /** Cancel transfer device to new account */
  cancelTransferDevice: DealerDevice;
  clearAdminCache: ClearAdminCachePayload;
  convertContract: Contract;
  createContractAmendment: Contract;
  /** Create a customer, linking it to the specified dealer. */
  createDealerCustomer: DealerCustomer;
  createDraftContract: Contract;
  createOrAssignOrganizationAndAddressToCustomer: DealerCustomer;
  createOrAssignOrganizationToCustomer: DealerCustomer;
  /** Creates a bulk ship-to-contact operation row and publishes the middleware CloudEvent. */
  createShipToContactBulkOperation: CreateBulkOperationResponse;
  /** Create a superkey for a dealer-owned device */
  createSuperkey: DealerDevice;
  declinePositiveRequest: PositiveRequest;
  /** Decline transfer request of a device */
  declineTransferRequest: DealerDevice;
  deleteAmendmentDraft: DeleteAmendmentDraftPayload;
  deleteDraft: DeleteDraftPayload;
  deleteNegativeRequest: DeleteNegativeRequestPayload;
  dismissApprovalRequest: Contract;
  /** Edit the dealer reference for a device */
  editDealerReference: DealerDevice;
  editRenewalQuote: Quote;
  ignoreDealerDashboardEvent: Scalars['Boolean']['output'];
  /** Link an existing customer to a dealer account. */
  linkExistingCustomerToDealer: DealerCustomer;
  /** Link an existing VW customer to a dealer account. */
  linkExistingVwCustomer: Scalars['Boolean']['output'];
  markAllAsRead: Scalars['Boolean']['output'];
  markAmendmentCancelledQuoteAsProcessed: MarkAmendmentCancelledQuoteAsProcessedPayload;
  markAsRead: MarkAsReadPayload;
  placeAmendmentOrder: Contract;
  recordRecentlyViewedItem: Scalars['Boolean']['output'];
  rejectOrderDraft: Scalars['Boolean']['output'];
  /** Remove a secondary owner from a customer account. The user's role will be downgraded to Product User. */
  removeSecondaryOwner: DealerCustomer;
  repriceContract: Contract;
  repriceQuote: Quote;
  /** Request transfer of a device the dealer does not hold */
  requestDeviceTransfer: DealerAddDeviceRequest;
  /** Request to opt in a dealer to manage a customer. */
  requestOptIn: DealerCustomer;
  requestProductPriceList: Scalars['Boolean']['output'];
  resendInvitation: Scalars['Boolean']['output'];
  restoreNotificationDefaults: Scalars['Boolean']['output'];
  /** Retries updating a contract's ship-to address to the customer's default ship-to address via a bulk operation. */
  retryBulkUpdateContractAddress: Contract;
  revokeLicense: RevokeSubscriptionResponse;
  revokeLicenseAndCancelTransfer: RevokeSubscriptionResponse;
  revokeLicenseAndTransferDevice: RevokeSubscriptionResponse;
  /** Revoke sku from superkey for a dealer-owned device */
  revokeSuperkey: DealerDevice;
  revokeUserLicense: RevokeUserSubscriptionResponse;
  saveAutoRenewSettings: Scalars['Boolean']['output'];
  saveCategoryNotificationPreference: Scalars['Boolean']['output'];
  saveChannelNotificationPreference: Scalars['Boolean']['output'];
  saveDealerAccountDefaults: Account;
  saveDealerCustomerDefaults: DealerCustomer;
  saveEventNotificationPreference: Scalars['Boolean']['output'];
  savePurchaseOrderNumber: Contract;
  saveQuotePONumber: Quote;
  saveSupportAdminDetails: Scalars['Boolean']['output'];
  saveUserEventPreferences: Scalars['Boolean']['output'];
  startContractRenewal: StartContractRenewalPayload;
  startDeviceExport: ExportDeviceResponse;
  submitDCountryHoldRequest: Scalars['Boolean']['output'];
  submitOrderDraftForReview: Scalars['Boolean']['output'];
  /** Transfer multiple devices to new account. */
  transferMultipleDevices: Array<DealerDevice>;
  updateAutoRenew: Contract;
  /** Update the customer users of a customer with the provided emails. Supports secondary owners and product users. Product users require dealer-customer opt-in. */
  updateCustomerUsers: DealerCustomer;
  /** Toggle revoke-at-check-in (auto-revoke) on a single offline license. Returns the updated license. */
  updateLicenseAutoRevoke: LicenseUnion;
  /** Update the secondary owners of a customer with the provided emails. */
  updateSecondaryOwners: DealerCustomer;
  updateTermUomAndRepriceRenewalContract: Contract;
  /** Verify the customer belongs to the Organization */
  verifyOrganization: DealerCustomer;
  /** Verify the customer belongs to the Organization, using the supplied customer address. */
  verifyOrganizationWithAddress: DealerCustomer;
  warmUpSession: WarmUpSessionResult;
  /**
   * Withdraws an approval request for a contract.
   * Supports different withdrawal types: Billing Frequency, Discount, or Promocode.
   * For Billing Frequency withdrawal, resets to UPFRONT and withdraws immediately.
   */
  withdrawApproval: Contract;
};


export type MutationAddSkusToSuperkeyArgs = {
  dealerAccountId: Scalars['ID']['input'];
  deviceId: Scalars['ID']['input'];
  skus: Array<SuperkeySkuRequestInput>;
};


export type MutationAlignEndDateAndRepriceRenewalContractArgs = {
  coTermContractId: Scalars['ID']['input'];
  contractId: Scalars['ID']['input'];
  quoteId: Scalars['String']['input'];
};


export type MutationApproveAndResubmitPricingArgs = {
  contractId: Scalars['ID']['input'];
  externalQuoteId: Scalars['ID']['input'];
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveTransferRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationAssignDevicesToSubscriptionArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  deviceIds: Array<Scalars['ID']['input']>;
  subscriptionId: Scalars['ID']['input'];
  transferOptions?: InputMaybe<TransferOptionsInput>;
};


export type MutationAssignSubscriptionsToDevicesArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  deviceIds: Array<Scalars['ID']['input']>;
  subscriptionIds: Array<Scalars['ID']['input']>;
  transferOptions?: InputMaybe<TransferOptionsInput>;
};


export type MutationAssignSubscriptionsToUsersArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  subscriptionIds: Array<Scalars['ID']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationCancelAmendmentArgs = {
  quoteId: Scalars['ID']['input'];
  statusChangeReason: ContractStatusReason;
};


export type MutationCancelContractArgs = {
  contractId: Scalars['ID']['input'];
  quoteId: Scalars['String']['input'];
  statusChangeReason: ContractStatusReason;
};


export type MutationCancelCustomerToDealerDeviceTransferRequestArgs = {
  dealerAccountId: Scalars['ID']['input'];
  deviceId: Scalars['ID']['input'];
};


export type MutationCancelInvitationArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  invitedEmail: Scalars['String']['input'];
};


export type MutationCancelTransferDeviceArgs = {
  iamDeviceId: Scalars['ID']['input'];
};


export type MutationConvertContractArgs = {
  id: Scalars['ID']['input'];
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateContractAmendmentArgs = {
  input: AmendmentQuoteInput;
};


export type MutationCreateDealerCustomerArgs = {
  createOrAssignOrganizationInput: CreateOrAssignOrganizationInput;
  dealerAccountId: Scalars['ID']['input'];
  input: CreateCustomerInput;
  optIn?: Scalars['Boolean']['input'];
};


export type MutationCreateDraftContractArgs = {
  input: CreateQuoteInput;
};


export type MutationCreateOrAssignOrganizationAndAddressToCustomerArgs = {
  input: CreateOrAssignOrganizationAndAddressToCustomerInput;
};


export type MutationCreateOrAssignOrganizationToCustomerArgs = {
  input: CreateOrAssignOrganizationToCustomerInput;
};


export type MutationCreateShipToContactBulkOperationArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  input: CreateShipToContactBulkOperationInput;
};


export type MutationCreateSuperkeyArgs = {
  dealerAccountId: Scalars['ID']['input'];
  deviceId: Scalars['ID']['input'];
  skus: Array<SuperkeySkuRequestInput>;
};


export type MutationDeclinePositiveRequestArgs = {
  contractId: Scalars['UUID']['input'];
  customerRequestId: Scalars['String']['input'];
  dealerComments: Scalars['String']['input'];
};


export type MutationDeclineTransferRequestArgs = {
  dealerAccountId: Scalars['ID']['input'];
  requestId: Scalars['ID']['input'];
};


export type MutationDeleteAmendmentDraftArgs = {
  input: DeleteAmendmentDraftInput;
};


export type MutationDeleteDraftArgs = {
  input: DeleteDraftInput;
};


export type MutationDeleteNegativeRequestArgs = {
  input: DeleteNegativeRequestInput;
};


export type MutationDismissApprovalRequestArgs = {
  input: DismissApprovalRequestInput;
};


export type MutationEditDealerReferenceArgs = {
  dealerAccountId: Scalars['String']['input'];
  iamDeviceId: Scalars['ID']['input'];
  reference: Scalars['String']['input'];
};


export type MutationEditRenewalQuoteArgs = {
  input: EditRenewalQuoteInput;
};


export type MutationIgnoreDealerDashboardEventArgs = {
  eventId: Scalars['UUID']['input'];
  undo?: Scalars['Boolean']['input'];
};


export type MutationLinkExistingCustomerToDealerArgs = {
  addressInput?: InputMaybe<AddressInput>;
  createOrAssignOrganizationInput?: InputMaybe<CreateOrAssignOrganizationInput>;
  customerAccountId: Scalars['ID']['input'];
  customerDefaults: SaveCustomerDefaultsInput;
  customerEmail: Scalars['String']['input'];
  dealerAccountId: Scalars['ID']['input'];
};


export type MutationLinkExistingVwCustomerArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
};


export type MutationMarkAllAsReadArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationMarkAmendmentCancelledQuoteAsProcessedArgs = {
  input: MarkAmendmentCancelledQuoteAsProcessedInput;
};


export type MutationMarkAsReadArgs = {
  accountId: Scalars['ID']['input'];
  notificationId: Scalars['ID']['input'];
};


export type MutationPlaceAmendmentOrderArgs = {
  contractId: Scalars['ID']['input'];
  externalQuoteId: Scalars['ID']['input'];
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordRecentlyViewedItemArgs = {
  input: RecordRecentlyViewedItemInput;
};


export type MutationRejectOrderDraftArgs = {
  contractId: Scalars['ID']['input'];
  externalQuoteId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
};


export type MutationRemoveSecondaryOwnerArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
};


export type MutationRepriceContractArgs = {
  input: RepriceContractInput;
};


export type MutationRepriceQuoteArgs = {
  input: AmendmentQuoteInput;
};


export type MutationRequestDeviceTransferArgs = {
  dealerAccountId: Scalars['ID']['input'];
  dealerNote?: InputMaybe<Scalars['String']['input']>;
  iamDeviceId: Scalars['ID']['input'];
};


export type MutationRequestOptInArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
};


export type MutationRequestProductPriceListArgs = {
  input: RequestProductPricelistInput;
};


export type MutationResendInvitationArgs = {
  customerAccountId: Scalars['ID']['input'];
  invitedEmail: Scalars['String']['input'];
};


export type MutationRestoreNotificationDefaultsArgs = {
  input: RestoreDefaultRequestInput;
};


export type MutationRetryBulkUpdateContractAddressArgs = {
  contractId: Scalars['ID']['input'];
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
};


export type MutationRevokeLicenseArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  deviceId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type MutationRevokeLicenseAndCancelTransferArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  deviceId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type MutationRevokeLicenseAndTransferDeviceArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  deviceId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type MutationRevokeSuperkeyArgs = {
  dealerAccountId: Scalars['ID']['input'];
  deviceId: Scalars['ID']['input'];
  skus: Array<SuperkeySkuRequestInput>;
};


export type MutationRevokeUserLicenseArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSaveAutoRenewSettingsArgs = {
  autoRenewEnabled: Scalars['Boolean']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  dealerAccountId: Scalars['ID']['input'];
};


export type MutationSaveCategoryNotificationPreferenceArgs = {
  input: SaveCategoryPreferenceRequestInput;
};


export type MutationSaveChannelNotificationPreferenceArgs = {
  input: SaveChannelPreferenceRequestInput;
};


export type MutationSaveDealerAccountDefaultsArgs = {
  dealerAccountId: Scalars['ID']['input'];
  input: SaveDealerAccountDefaultsInput;
};


export type MutationSaveDealerCustomerDefaultsArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  input: SaveCustomerDefaultsInput;
};


export type MutationSaveEventNotificationPreferenceArgs = {
  input: SaveEventPreferenceRequestInput;
};


export type MutationSavePurchaseOrderNumberArgs = {
  contractId: Scalars['ID']['input'];
  externalQuoteId: Scalars['ID']['input'];
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveQuotePoNumberArgs = {
  contractId: Scalars['ID']['input'];
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  quoteId: Scalars['ID']['input'];
};


export type MutationSaveSupportAdminDetailsArgs = {
  input: SupportAdminRequestInput;
};


export type MutationSaveUserEventPreferencesArgs = {
  input: SaveBulkUserEventPreferencesRequestInput;
};


export type MutationStartContractRenewalArgs = {
  input: StartContractRenewalInput;
};


export type MutationStartDeviceExportArgs = {
  input: DeviceExportInput;
  order?: InputMaybe<Array<DealerDeviceSortInput>>;
  where?: InputMaybe<DealerDeviceFilterInput>;
};


export type MutationSubmitDCountryHoldRequestArgs = {
  contractId: Scalars['ID']['input'];
  formFields: DCountryFormFieldsInput;
  formType: DCountryFormType;
  quoteId: Scalars['String']['input'];
  submittedStatus: ContractStatusReason;
};


export type MutationSubmitOrderDraftForReviewArgs = {
  contractId: Scalars['ID']['input'];
  externalQuoteId: Scalars['ID']['input'];
};


export type MutationTransferMultipleDevicesArgs = {
  customerAccountCDHId: Scalars['String']['input'];
  iamDeviceIds: Array<Scalars['ID']['input']>;
  transferDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateAutoRenewArgs = {
  contractId: Scalars['ID']['input'];
  isAutoRenew: Scalars['Boolean']['input'];
};


export type MutationUpdateCustomerUsersArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  input: UpdateCustomerUsersInput;
};


export type MutationUpdateLicenseAutoRevokeArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  licenseId: Scalars['ID']['input'];
  revokeAtCheckIn: Scalars['Boolean']['input'];
};


export type MutationUpdateSecondaryOwnersArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  secondaryOwnerEmails: Array<Scalars['String']['input']>;
};


export type MutationUpdateTermUomAndRepriceRenewalContractArgs = {
  contractId: Scalars['ID']['input'];
  quoteId: Scalars['String']['input'];
  termUOMType: TermUomType;
};


export type MutationVerifyOrganizationArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationVerifyOrganizationWithAddressArgs = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  customerAccountId: Scalars['ID']['input'];
  customerAddress: AddressInput;
  dealerAccountId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationWithdrawApprovalArgs = {
  input: WithdrawApprovalInput;
};

export type NegativeRequest = {
  __typename?: 'NegativeRequest';
  action: QuoteActionType;
  contract?: Maybe<Contract>;
  createdByUserName?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  customerFeedback?: Maybe<CustomerFeedback>;
  customerRequestId?: Maybe<Scalars['UUID']['output']>;
  feedback?: Maybe<CustomerFeedback>;
  id: Scalars['UUID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  licenseSelectionType?: Maybe<LicenseSelectionType>;
  lines: Array<NegativeRequestLine>;
  parentProduct?: Maybe<Product>;
  product: Product;
  quantity: Scalars['Int']['output'];
  userComment?: Maybe<Scalars['String']['output']>;
};

export type NegativeRequestFilterInput = {
  action?: InputMaybe<QuoteActionTypeOperationFilterInput>;
  and?: InputMaybe<Array<NegativeRequestFilterInput>>;
  customerRequestId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<NegativeRequestFilterInput>>;
};

export type NegativeRequestLine = {
  __typename?: 'NegativeRequestLine';
  entitlementId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  invitedUserEmail?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  licenseId?: Maybe<Scalars['String']['output']>;
  lineNumber?: Maybe<Scalars['String']['output']>;
  metaCreatedDateTime: Scalars['DateTime']['output'];
  metaUpdatedDateTime?: Maybe<Scalars['DateTime']['output']>;
  negativeRequest?: Maybe<NegativeRequest>;
  negativeRequestId: Scalars['UUID']['output'];
  quantity: Scalars['Int']['output'];
};

export type NegativeRequestSortInput = {
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type Notification = {
  __typename?: 'Notification';
  contentUri: Scalars['String']['output'];
  createdDateTime: Scalars['DateTime']['output'];
  data?: Maybe<NotificationData>;
  id: Scalars['ID']['output'];
  notificationStatus: UserNotificationStatus;
  notificationType: NotificationType;
};

export const NotificationChannel = {
  CustomerEmail: 'CUSTOMER_EMAIL',
  Email: 'EMAIL',
  Inapp: 'INAPP'
} as const;

export type NotificationChannel = typeof NotificationChannel[keyof typeof NotificationChannel];
export type NotificationData = AutoRenewUpdateNotification | BulkStatusNotification | ContractApprovalStatusNotification | ContractStatusNotification | CustomerTransferDeviceNotification | DealerDeviceTransferNotification | DeviceStatusNotification | PriceListNotification;

export const NotificationEvent = {
  AddDeviceRequest: 'ADD_DEVICE_REQUEST',
  AmendmentActivated: 'AMENDMENT_ACTIVATED',
  AmendmentCancelled: 'AMENDMENT_CANCELLED',
  AmendmentError: 'AMENDMENT_ERROR',
  AmendmentInProgress: 'AMENDMENT_IN_PROGRESS',
  AmendmentOnHold: 'AMENDMENT_ON_HOLD',
  AmendmentSubmitted: 'AMENDMENT_SUBMITTED',
  ApprovalRequestStatus: 'APPROVAL_REQUEST_STATUS',
  ContractActivated: 'CONTRACT_ACTIVATED',
  ContractActivationInProgress: 'CONTRACT_ACTIVATION_IN_PROGRESS',
  ContractAutoRenewalEnabledDisabled: 'CONTRACT_AUTO_RENEWAL_ENABLED_DISABLED',
  ContractBulkShipTo: 'CONTRACT_BULK_SHIP_TO',
  ContractCancelled: 'CONTRACT_CANCELLED',
  ContractError: 'CONTRACT_ERROR',
  ContractExpired: 'CONTRACT_EXPIRED',
  ContractMissingBaseProducts: 'CONTRACT_MISSING_BASE_PRODUCTS',
  ContractOnHold: 'CONTRACT_ON_HOLD',
  ContractPendingActivation: 'CONTRACT_PENDING_ACTIVATION',
  ContractSubmitted: 'CONTRACT_SUBMITTED',
  CustomerAccountInvitationNotAccepted: 'CUSTOMER_ACCOUNT_INVITATION_NOT_ACCEPTED',
  CustomerRequestAmendmentAcceptedDeclined: 'CUSTOMER_REQUEST_AMENDMENT_ACCEPTED_DECLINED',
  CustomerRequestAmendmentDeleted: 'CUSTOMER_REQUEST_AMENDMENT_DELETED',
  CustomerRequestAmendmentModified: 'CUSTOMER_REQUEST_AMENDMENT_MODIFIED',
  CustomerRequestNewAmendmentReceived: 'CUSTOMER_REQUEST_NEW_AMENDMENT_RECEIVED',
  DeviceBlocked: 'DEVICE_BLOCKED',
  DeviceTransferredBack: 'DEVICE_TRANSFERRED_BACK',
  DeviceUnblocked: 'DEVICE_UNBLOCKED',
  MonthAutoRenewalSuccessful: 'MONTH_AUTO_RENEWAL_SUCCESSFUL',
  MonthContractExpiresToday: 'MONTH_CONTRACT_EXPIRES_TODAY',
  MonthEarlyRenewalEligibility: 'MONTH_EARLY_RENEWAL_ELIGIBILITY',
  MonthLateRenewalExpiresToday: 'MONTH_LATE_RENEWAL_EXPIRES_TODAY',
  MonthLateRenewalReminder: 'MONTH_LATE_RENEWAL_REMINDER',
  MonthManualRenewalSuccessful: 'MONTH_MANUAL_RENEWAL_SUCCESSFUL',
  MonthRenewalQuoteGenerated: 'MONTH_RENEWAL_QUOTE_GENERATED',
  MonthRenewalSubmitted: 'MONTH_RENEWAL_SUBMITTED',
  MonthUpcomingExpiration: 'MONTH_UPCOMING_EXPIRATION',
  MonthUpcomingRenewalQuote: 'MONTH_UPCOMING_RENEWAL_QUOTE',
  OptInGrantedByCustomer: 'OPT_IN_GRANTED_BY_CUSTOMER',
  OptInRequestConfirmation: 'OPT_IN_REQUEST_CONFIRMATION',
  OptInRequestDeclined: 'OPT_IN_REQUEST_DECLINED',
  OptInRequestExpired: 'OPT_IN_REQUEST_EXPIRED',
  OptInRevokedByCustomer: 'OPT_IN_REVOKED_BY_CUSTOMER',
  Unknown: 'UNKNOWN',
  YearAutoRenewalReminderEmail: 'YEAR_AUTO_RENEWAL_REMINDER_EMAIL',
  YearAutoRenewalReminderInapp: 'YEAR_AUTO_RENEWAL_REMINDER_INAPP',
  YearAutoRenewalSuccessful: 'YEAR_AUTO_RENEWAL_SUCCESSFUL',
  YearContractExpiresToday: 'YEAR_CONTRACT_EXPIRES_TODAY',
  YearEarlyRenewalEligibility: 'YEAR_EARLY_RENEWAL_ELIGIBILITY',
  YearLateRenewalExpiresToday: 'YEAR_LATE_RENEWAL_EXPIRES_TODAY',
  YearLateRenewalReminder: 'YEAR_LATE_RENEWAL_REMINDER',
  YearManualRenewalSuccessful: 'YEAR_MANUAL_RENEWAL_SUCCESSFUL',
  YearRenewalQuoteGenerated: 'YEAR_RENEWAL_QUOTE_GENERATED',
  YearRenewalReminder: 'YEAR_RENEWAL_REMINDER',
  YearRenewalSubmitted: 'YEAR_RENEWAL_SUBMITTED',
  YearUpcomingAutoRenewal: 'YEAR_UPCOMING_AUTO_RENEWAL',
  YearUpcomingExpiration: 'YEAR_UPCOMING_EXPIRATION',
  YearUpcomingRenewalQuote: 'YEAR_UPCOMING_RENEWAL_QUOTE'
} as const;

export type NotificationEvent = typeof NotificationEvent[keyof typeof NotificationEvent];
export const NotificationEventCategory = {
  ApprovalRequest: 'APPROVAL_REQUEST',
  BulkOperation: 'BULK_OPERATION',
  Contract: 'CONTRACT',
  CustomerAccount: 'CUSTOMER_ACCOUNT',
  CustomerRequest: 'CUSTOMER_REQUEST',
  Devices: 'DEVICES',
  ExpirationRenewal: 'EXPIRATION_RENEWAL',
  OptInRequest: 'OPT_IN_REQUEST'
} as const;

export type NotificationEventCategory = typeof NotificationEventCategory[keyof typeof NotificationEventCategory];
export type NotificationFilterInput = {
  and?: InputMaybe<Array<NotificationFilterInput>>;
  notificationStatus?: InputMaybe<UserNotificationStatusOperationFilterInput>;
  notificationType?: InputMaybe<NotificationTypeOperationFilterInput>;
  or?: InputMaybe<Array<NotificationFilterInput>>;
};

export type NotificationPreferenceChangeAuditItem = {
  __typename?: 'NotificationPreferenceChangeAuditItem';
  eventName?: Maybe<Scalars['String']['output']>;
  eventTypeId: Scalars['Int']['output'];
  ignoreNotification: Scalars['Boolean']['output'];
};

export const NotificationReason = {
  AutoRenewalReminderFirst: 'AUTO_RENEWAL_REMINDER_FIRST',
  AutoRenewalReminderSecond: 'AUTO_RENEWAL_REMINDER_SECOND',
  ContractActivationReminder: 'CONTRACT_ACTIVATION_REMINDER',
  ContractHasOutstandingItems: 'CONTRACT_HAS_OUTSTANDING_ITEMS',
  InvitationExpired: 'INVITATION_EXPIRED',
  InvitationFailed: 'INVITATION_FAILED',
  RenewalAddonMissingBase: 'RENEWAL_ADDON_MISSING_BASE',
  RenewalExpiresToday: 'RENEWAL_EXPIRES_TODAY',
  RenewalGeneralReminder: 'RENEWAL_GENERAL_REMINDER',
  RenewalImpendingReminder: 'RENEWAL_IMPENDING_REMINDER',
  RenewalInitiationError: 'RENEWAL_INITIATION_ERROR',
  RenewalLate: 'RENEWAL_LATE',
  RenewalLateExpired: 'RENEWAL_LATE_EXPIRED',
  RenewalRegular: 'RENEWAL_REGULAR',
  RenewalSubmitted: 'RENEWAL_SUBMITTED',
  RenewalUpcomingExpiry: 'RENEWAL_UPCOMING_EXPIRY',
  Unknown: 'UNKNOWN'
} as const;

export type NotificationReason = typeof NotificationReason[keyof typeof NotificationReason];
export type NotificationSortInput = {
  createdDateTime?: InputMaybe<SortEnumType>;
  notificationStatus?: InputMaybe<SortEnumType>;
  notificationType?: InputMaybe<SortEnumType>;
};

export const NotificationType = {
  ApprovalRequest: 'APPROVAL_REQUEST',
  AutoRenewalUpdate: 'AUTO_RENEWAL_UPDATE',
  BulkShipToAddress: 'BULK_SHIP_TO_ADDRESS',
  BulkShipToContact: 'BULK_SHIP_TO_CONTACT',
  ContractStatus: 'CONTRACT_STATUS',
  CustomerDeviceTransfer: 'CUSTOMER_DEVICE_TRANSFER',
  CustomerRequest: 'CUSTOMER_REQUEST',
  DeviceStatus: 'DEVICE_STATUS',
  DeviceTransferredToAnotherDealer: 'DEVICE_TRANSFERRED_TO_ANOTHER_DEALER',
  DeviceTransferRequestApproved: 'DEVICE_TRANSFER_REQUEST_APPROVED',
  DeviceTransferRequestCancelled: 'DEVICE_TRANSFER_REQUEST_CANCELLED',
  DeviceTransferRequestDeclined: 'DEVICE_TRANSFER_REQUEST_DECLINED',
  DeviceTransferRequestExpired: 'DEVICE_TRANSFER_REQUEST_EXPIRED',
  InvitationStatus: 'INVITATION_STATUS',
  PricelistGenerationFailed: 'PRICELIST_GENERATION_FAILED',
  Renewal: 'RENEWAL'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];
export type NotificationTypeOperationFilterInput = {
  eq?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  neq?: InputMaybe<NotificationType>;
  nin?: InputMaybe<Array<NotificationType>>;
};

/** A connection to a list of items. */
export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<NotificationsEdge>>;
  hasUnReadNotifications: Scalars['Boolean']['output'];
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationsEdge = {
  __typename?: 'NotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Notification;
};

export type NullableOfApprovalRequestTypeOperationFilterInput = {
  eq?: InputMaybe<ApprovalRequestType>;
  in?: InputMaybe<Array<InputMaybe<ApprovalRequestType>>>;
  neq?: InputMaybe<ApprovalRequestType>;
  nin?: InputMaybe<Array<InputMaybe<ApprovalRequestType>>>;
};

export type NullableOfApprovalStatusOperationFilterInput = {
  eq?: InputMaybe<ApprovalStatus>;
  in?: InputMaybe<Array<InputMaybe<ApprovalStatus>>>;
  neq?: InputMaybe<ApprovalStatus>;
  nin?: InputMaybe<Array<InputMaybe<ApprovalStatus>>>;
};

export type NullableOfContractStatusReasonOperationFilterInput = {
  eq?: InputMaybe<ContractStatusReason>;
  in?: InputMaybe<Array<InputMaybe<ContractStatusReason>>>;
  neq?: InputMaybe<ContractStatusReason>;
  nin?: InputMaybe<Array<InputMaybe<ContractStatusReason>>>;
};

export type NullableOfDealerUserRoleOperationFilterInput = {
  eq?: InputMaybe<DealerUserRole>;
  in?: InputMaybe<Array<InputMaybe<DealerUserRole>>>;
  neq?: InputMaybe<DealerUserRole>;
  nin?: InputMaybe<Array<InputMaybe<DealerUserRole>>>;
};

export type NullableOfDeviceStatusOperationFilterInput = {
  eq?: InputMaybe<DeviceStatus>;
  in?: InputMaybe<Array<InputMaybe<DeviceStatus>>>;
  neq?: InputMaybe<DeviceStatus>;
  nin?: InputMaybe<Array<InputMaybe<DeviceStatus>>>;
};

export type OfflineLicense = {
  __typename?: 'OfflineLicense';
  checkInDate: Scalars['DateTime']['output'];
  checkOutDate: Scalars['DateTime']['output'];
  holderId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  revokeWhenOnline: Scalars['Boolean']['output'];
};

export const OptInStatus = {
  Approved: 'APPROVED',
  Cancelled: 'CANCELLED',
  Committed: 'COMMITTED',
  Declined: 'DECLINED',
  Expired: 'EXPIRED',
  Granted: 'GRANTED',
  None: 'NONE',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  Requested: 'REQUESTED',
  Revoked: 'REVOKED'
} as const;

export type OptInStatus = typeof OptInStatus[keyof typeof OptInStatus];
export type Organization = {
  __typename?: 'Organization';
  address?: Maybe<Address>;
  contact?: Maybe<Contact>;
  id: Scalars['ID']['output'];
  industry?: Maybe<IndustrySector>;
  name?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSearchRequestInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Deprecated: use AccountCommon. Kept so existing fragments on OwnerUnion keep validating. */
export type OwnerUnion = Account | AnonymisedOwner | DealerCustomer;

export type PackageBundleDto = {
  __typename?: 'PackageBundleDTO';
  childSkuDescription: Scalars['String']['output'];
  childSkuId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PendingUser = {
  __typename?: 'PendingUser';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: UserRole;
  roles: Array<UserRole>;
  status: UserStatus;
};

export const PerformedByType = {
  Admin: 'ADMIN',
  System: 'SYSTEM',
  User: 'USER'
} as const;

export type PerformedByType = typeof PerformedByType[keyof typeof PerformedByType];
export type PerformedByTypeOperationFilterInput = {
  eq?: InputMaybe<PerformedByType>;
  in?: InputMaybe<Array<PerformedByType>>;
  neq?: InputMaybe<PerformedByType>;
  nin?: InputMaybe<Array<PerformedByType>>;
};

/**
 * Permission actions within a category.
 * Values must match the IAM Action field (case-insensitive).
 */
export const PermissionAction = {
  Create: 'CREATE',
  CreateAndManage: 'CREATE_AND_MANAGE',
  Export: 'EXPORT',
  Manage: 'MANAGE',
  ManageSettings: 'MANAGE_SETTINGS',
  OptInAndManage: 'OPT_IN_AND_MANAGE',
  SecondaryOwnerManage: 'SECONDARY_OWNER_MANAGE',
  View: 'VIEW'
} as const;

export type PermissionAction = typeof PermissionAction[keyof typeof PermissionAction];
/**
 * Permission categories matching the IAM resource domain.
 * Values must match the IAM Resource field (case-insensitive).
 */
export const PermissionCategory = {
  Audit: 'AUDIT',
  Contract: 'CONTRACT',
  Customer: 'CUSTOMER',
  Dealer: 'DEALER',
  Device: 'DEVICE',
  EmailSettings: 'EMAIL_SETTINGS',
  Invoice: 'INVOICE',
  Notification: 'NOTIFICATION',
  Organization: 'ORGANIZATION',
  Product: 'PRODUCT',
  Renewal: 'RENEWAL',
  Subscription: 'SUBSCRIPTION'
} as const;

export type PermissionCategory = typeof PermissionCategory[keyof typeof PermissionCategory];
export type PositiveRequest = {
  __typename?: 'PositiveRequest';
  contractId: Scalars['UUID']['output'];
  createdDate: Scalars['DateTime']['output'];
  customerRequestId: Scalars['ID']['output'];
  dealerComments?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  /** List of lines associated with this positive request. */
  lines?: Maybe<Array<PositiveRequestLine>>;
  status: CustomerRequestStatus;
  updatedByUserEmail?: Maybe<Scalars['String']['output']>;
  updatedByUserName?: Maybe<Scalars['String']['output']>;
  userComments?: Maybe<Scalars['String']['output']>;
  validUntilDate: Scalars['DateTime']['output'];
};

export type PositiveRequestFilterInput = {
  and?: InputMaybe<Array<PositiveRequestFilterInput>>;
  customerRequestId?: InputMaybe<UuidOperationFilterInput>;
  customerRequestStatus?: InputMaybe<CustomerRequestStatusOperationFilterInput>;
  or?: InputMaybe<Array<PositiveRequestFilterInput>>;
};

export type PositiveRequestLine = {
  __typename?: 'PositiveRequestLine';
  action?: Maybe<QuoteActionType>;
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lineNumber?: Maybe<Scalars['String']['output']>;
  parentProduct?: Maybe<Product>;
  product?: Maybe<Product>;
  quantity: Scalars['Int']['output'];
};

export type PriceListNotification = {
  __typename?: 'PriceListNotification';
  requestId?: Maybe<Scalars['UUID']['output']>;
};

export type Product = {
  __typename?: 'Product';
  addOns: Array<ProductAddOn>;
  allowDuplicateAssignment: Scalars['Boolean']['output'];
  bundleContent: Array<ProductBundle>;
  description: Scalars['String']['output'];
  downgrades: Array<Product>;
  family: ProductFamily;
  /** The sku of the product. */
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isNonTransferable: Scalars['Boolean']['output'];
  isSuperKeyEligible?: Maybe<Scalars['Boolean']['output']>;
  metric?: Maybe<ProductSkuMetric>;
  productPricing?: Maybe<ProductPricing>;
  productType: ProductClassification;
  skuType?: Maybe<SkuType>;
  /**
   * The audience a product is sold for. The underlying column is an array, but a product is
   * only ever expected to target a single audience, so this surfaces the first parseable value.
   */
  subscriptionFor?: Maybe<SubscriptionTarget>;
  subscriptionModel: SubscriptionModelType;
  trialDuration?: Maybe<Scalars['Int']['output']>;
  upgrades: Array<Product>;
};

/** Represents an add-on product relationship where an add-on SKU is associated with a base SKU. */
export type ProductAddOn = {
  __typename?: 'ProductAddOn';
  addOnSkuId: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
};

/** Represents a product bundle association between parent and child products. */
export type ProductBundle = {
  __typename?: 'ProductBundle';
  childSku?: Maybe<Product>;
  childSkuId: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
  parentSkuId: Scalars['ID']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

/**
 * Response DTO for the GetProductsByProductId query.
 * Returns the product and its upgrade/downgrade hierarchy without portfolio filtering.
 */
export type ProductByProductIdResponse = {
  __typename?: 'ProductByProductIdResponse';
  downgrades: Array<ProductHierarchyItem>;
  id: Scalars['String']['output'];
  upgrades: Array<ProductHierarchyItem>;
};

export const ProductClassification = {
  Addon: 'ADDON',
  Base: 'BASE'
} as const;

export type ProductClassification = typeof ProductClassification[keyof typeof ProductClassification];
export type ProductFamily = {
  __typename?: 'ProductFamily';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  products: Array<Product>;
  type: ProductFamilyType;
};

export const ProductFamilyType = {
  Device: 'DEVICE',
  User: 'USER'
} as const;

export type ProductFamilyType = typeof ProductFamilyType[keyof typeof ProductFamilyType];
/** A single item in a product's upgrade or downgrade hierarchy. */
export type ProductHierarchyItem = {
  __typename?: 'ProductHierarchyItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ProductLineUnion = ContractLine | ExternalContractLine;

export type ProductPricing = {
  __typename?: 'ProductPricing';
  currency: Currency;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  listPrice: Scalars['Decimal']['output'];
  product: Product;
  termUOM: TermUomType;
};

export type ProductSkuMetric = {
  __typename?: 'ProductSkuMetric';
  type?: Maybe<ProductSkuMetricType>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export const ProductSkuMetricType = {
  Storage: 'STORAGE'
} as const;

export type ProductSkuMetricType = typeof ProductSkuMetricType[keyof typeof ProductSkuMetricType];
export type PurchasedAccountBasedEntitlement = {
  __typename?: 'PurchasedAccountBasedEntitlement';
  /** When a pending entitlement becomes active. */
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<ContractStatusType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** False marks a pending entitlement; pending entitlements are excluded from purchased-product results. Null when activation is not specified. */
  isActivated?: Maybe<Scalars['Boolean']['output']>;
  metric?: Maybe<Scalars['String']['output']>;
  /** Null when the contract has no PO number. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** Purchased units. */
  quantity: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Storage granted by the entitlement in `metric`. */
  totalValue?: Maybe<Scalars['Int']['output']>;
};

export type PurchasedAccountBasedProduct = {
  __typename?: 'PurchasedAccountBasedProduct';
  /** Number of distinct contracts with an active entitlement for the SKU. */
  activeContractCount: Scalars['Int']['output'];
  /** Per-contract breakdown of the active entitlements, ordered by end date. Lists only the requesting dealer's own active contracts; the totals above cover all active contracts. */
  entitlements: Array<PurchasedAccountBasedEntitlement>;
  /** Unit of the storage values, for example GB. */
  metric?: Maybe<Scalars['String']['output']>;
  product: Product;
  skuId: Scalars['ID']['output'];
  /** Units across the active entitlements. */
  totalQuantity: Scalars['Int']['output'];
  /** Storage of the active entitlements in `metric`: their totalValue, or quantity x 200 GB when none is given. */
  totalValue: Scalars['Int']['output'];
};

export type PurchasedEntitlement = {
  __typename?: 'PurchasedEntitlement';
  assignedQuantity: Scalars['Int']['output'];
  contractId?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<ContractStatusType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Null when the contract has no PO number. */
  poNumber?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  totalQuantity: Scalars['Int']['output'];
  unassignedQuantity: Scalars['Int']['output'];
};

export type PurchasedProduct = {
  __typename?: 'PurchasedProduct';
  /** Number of distinct contracts with an active entitlement for the SKU. When `isTrial` is true, this represents the number of active trial contracts. */
  activeContractCount: Scalars['Int']['output'];
  /** Seats in use or reserved. */
  assignedQuantity: Scalars['Int']['output'];
  /** Per-contract breakdown of the active entitlements, ordered by end date. Lists only the requesting dealer's own active contracts; the totals above cover all active contracts. */
  entitlements: Array<PurchasedEntitlement>;
  product: Product;
  skuId: Scalars['ID']['output'];
  totalQuantity: Scalars['Int']['output'];
  unassignedQuantity: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  accounts: Array<Account>;
  accountsV2: Array<IamAccountSummary>;
  amendments?: Maybe<AmendmentsConnection>;
  applicationLogEventTypes: Array<ApplicationLogEventTypeDto>;
  auditLogs?: Maybe<AuditLogsConnection>;
  autoRenewSettings: Scalars['Boolean']['output'];
  /** Gets available customer subscriptions by devices. */
  availableCustomerSubscriptionsByDevices: SubscriptionResponse;
  /** Gets available customer SuperKey subscriptions by devices. */
  availableSuperKeysByDevices: SuperKeyResponse;
  /** Gets available user subscriptions for a customer. */
  availableUserSubscriptions: SubscriptionResponse;
  /** Fetch software bundle content for multiple bundle SKUs. Returns a list of entries per bundle SKU; each entry has key (bundle SKU) and value (list of bundle items). */
  bundleContent: Array<BundleContentBySku>;
  canUseFeature: Scalars['Boolean']['output'];
  /** Checks trial eligibility for an account and SKU combination. */
  checkTrialEligibility: TrialEligibilityResponse;
  /** Checks trial eligibility for an account and multiple SKUs in parallel. */
  checkTrialEligibilityBatch: Array<TrialEligibilityResponse>;
  coTermContracts?: Maybe<CoTermContractsConnection>;
  contract: Contract;
  contractVersionById: ContractVersionOutput;
  contractsV2?: Maybe<ContractsV2Connection>;
  creditMemos?: Maybe<CreditMemosConnection>;
  /** Returns the list of currencies available for use. */
  currencies: Array<Currency>;
  dealerCustomerAccountEntitlements?: Maybe<Array<AccountEntitlement>>;
  dealerCustomerById?: Maybe<DealerCustomer>;
  /** Gets a dealer device by serial number and model for a dealer customer. */
  dealerCustomerDeviceBySerialNumber: DealerCustomerDeviceDto;
  /** Checks that a given sku is assignable and not already assigned to a device or its family */
  dealerCustomerDeviceBySerialNumberAndSku: DealerDevice;
  /** Account-based products the customer has purchased, grouped by product. Totals cover the customer's account-based entitlements under active contracts; the contract breakdown lists only the dealer's own. */
  dealerCustomerPurchasedAccountBasedProducts: Array<PurchasedAccountBasedProduct>;
  /** User and device (seat-based) products the customer has purchased, grouped by product. Set isTrial to list the customer's trial products instead of the standard ones. Account-based products are listed by dealerCustomerPurchasedAccountBasedProducts. A dealer that is not opted in only sees the entitlements of its own contracts; an opted-in dealer sees the customer's entitlements across all dealers. */
  dealerCustomerPurchasedProducts: Array<PurchasedProduct>;
  dealerCustomerUserById: UserUnion;
  dealerCustomerUsers?: Maybe<UsersConnection>;
  dealerCustomers: Array<DealerCustomer>;
  dealerCustomersByOwnerEmail: Array<DealerCustomer>;
  dealerCustomersPaged?: Maybe<DealerCustomersPagedConnection>;
  dealerDashboardEvents?: Maybe<DealerDashboardEventsConnection>;
  dealerDevices?: Maybe<DealerDevicesConnection>;
  dealerInvoice: DealerInvoice;
  dealerInvoiceByExternalId: DealerInvoice;
  dealerInvoices?: Maybe<DealerInvoicesConnection>;
  dealerInvoicesByContractId: Array<DealerInvoice>;
  dealerUsers: Array<DealerUser>;
  deviceModels: Array<DeviceModel>;
  deviceSearch: DeviceSearchResult;
  enabledFeatureFlags: Array<UiFeatureFlagNames>;
  lookups: LookupLists;
  me: DealerUser;
  notificationPreferences: Array<AccountNotificationPreferenceDto>;
  notifications?: Maybe<NotificationsConnection>;
  positiveRequest: PositiveRequest;
  product?: Maybe<Product>;
  productTermCompatibility: Array<Product>;
  products: Array<Product>;
  /** @deprecated Returns upgrade/downgrade hierarchy for a single product without portfolio filtering. Consider using the 'product' query for general single-product access. */
  productsByProductId: Array<ProductByProductIdResponse>;
  quote: Quote;
  recentlyViewedItems: Array<RecentlyViewedItem>;
  searchAddress: Array<ValidatedAddress>;
  searchDealerAccounts: Array<DealerAccountSearchResult>;
  /** Search for organizations. */
  searchOrganizations: Array<Organization>;
  searchUsersByEmailId: Array<Maybe<DealerUserSearchResult>>;
  shipToContactBulkDetails: Array<ShipToContactBulkDetails>;
  shipToContactBulkDetailsById: ShipToContactBulkDetails;
  shipToContactIdsForCustomer: Array<Scalars['String']['output']>;
  /** Validates add-on / base product pairings for the current transaction. Returns missingBase (add-ons being added that have no compatible base, plus add-ons left unsupported after removals) and removedBase (base products being removed that orphan an add-on on the contract). */
  validateAddOnBase: AddOnBaseValidationResult;
  validateAddress: Array<ValidatedAddress>;
  validateContractProductsPricing: ValidateContractProductsPricingResult;
  validateCustomerUserEmail: EmailValidationResponse;
  validateCustomerUserEmails: BulkEmailValidationResponse;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAmendmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<QuoteSortInput>>;
  where?: InputMaybe<QuoteFilterInput>;
};


export type QueryAuditLogsArgs = {
  accountId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeSystemLogs?: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ApplicationAuditLogEntrySortInput>>;
  where?: InputMaybe<ApplicationAuditLogEntryFilterInput>;
};


export type QueryAutoRenewSettingsArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  dealerAccountId: Scalars['ID']['input'];
};


export type QueryAvailableCustomerSubscriptionsByDevicesArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  deviceIds: Array<Scalars['ID']['input']>;
};


export type QueryAvailableSuperKeysByDevicesArgs = {
  dealerAccountId: Scalars['ID']['input'];
  deviceIds: Array<Scalars['ID']['input']>;
};


export type QueryAvailableUserSubscriptionsArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBundleContentArgs = {
  bundleSkus: Array<Scalars['ID']['input']>;
};


export type QueryCanUseFeatureArgs = {
  accountId: Scalars['ID']['input'];
  flagName: UiFeatureFlagNames;
};


export type QueryCheckTrialEligibilityArgs = {
  accountId: Scalars['ID']['input'];
  skuId: Scalars['ID']['input'];
};


export type QueryCheckTrialEligibilityBatchArgs = {
  accountId: Scalars['ID']['input'];
  skuIds: Array<Scalars['ID']['input']>;
};


export type QueryCoTermContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContractSortInput>>;
  where?: InputMaybe<ContractFilterInput>;
};


export type QueryContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractVersionByIdArgs = {
  contractId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type QueryContractsV2Args = {
  accountId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContractSortInput>>;
  where?: InputMaybe<ContractFilterInput>;
};


export type QueryCreditMemosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dealerAccountId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CreditMemoSortInput>>;
  where?: InputMaybe<CreditMemoFilterInput>;
};


export type QueryDealerCustomerAccountEntitlementsArgs = {
  customerAccountId: Scalars['ID']['input'];
};


export type QueryDealerCustomerByIdArgs = {
  customerId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
};


export type QueryDealerCustomerDeviceBySerialNumberArgs = {
  customerAccountId: Scalars['ID']['input'];
  model: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


export type QueryDealerCustomerDeviceBySerialNumberAndSkuArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  serialNumber: Scalars['String']['input'];
};


export type QueryDealerCustomerPurchasedAccountBasedProductsArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
};


export type QueryDealerCustomerPurchasedProductsArgs = {
  customerAccountId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  isTrial?: Scalars['Boolean']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDealerCustomerUserByIdArgs = {
  customerId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryDealerCustomerUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DealerCustomerUsersSortInput>>;
  where?: InputMaybe<DealerCustomerUsersFilterInput>;
};


export type QueryDealerCustomersArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryDealerCustomersByOwnerEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryDealerCustomersPagedArgs = {
  accountId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DealerCustomerFilterInput>;
};


export type QueryDealerDashboardEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AttentionEventSortInput>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<DealerDashboardFilterInput>;
};


export type QueryDealerDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dealerAccountId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  initialise: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DealerDeviceSortInput>>;
  unassignedOnly?: Scalars['Boolean']['input'];
  where?: InputMaybe<DealerDeviceFilterInput>;
};


export type QueryDealerInvoiceArgs = {
  contractId: Scalars['ID']['input'];
  dealerAccountId: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
};


export type QueryDealerInvoiceByExternalIdArgs = {
  dealerAccountId: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
};


export type QueryDealerInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dealerAccountId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DealerInvoiceSortInput>>;
  where?: InputMaybe<DealerInvoiceFilterInput>;
};


export type QueryDealerInvoicesByContractIdArgs = {
  contractId: Scalars['ID']['input'];
  dealerAccountId: Scalars['String']['input'];
};


export type QueryDealerUsersArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryDeviceSearchArgs = {
  modelName: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};


export type QueryEnabledFeatureFlagsArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryNotificationPreferencesArgs = {
  customerAccountId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationsArgs = {
  accountId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<NotificationSortInput>>;
  where?: InputMaybe<NotificationFilterInput>;
};


export type QueryPositiveRequestArgs = {
  contractId: Scalars['ID']['input'];
  requestId: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  accountId: Scalars['ID']['input'];
  contractId?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['ID']['input'];
  termUom?: InputMaybe<TermUomType>;
};


export type QueryProductTermCompatibilityArgs = {
  contractId: Scalars['ID']['input'];
  termUOMType: TermUomType;
};


export type QueryProductsArgs = {
  accountId: Scalars['ID']['input'];
  contractId?: InputMaybe<Scalars['UUID']['input']>;
  contractType?: InputMaybe<ContractType>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  currencyId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  termUom?: InputMaybe<TermUomType>;
};


export type QueryProductsByProductIdArgs = {
  accountId: Scalars['ID']['input'];
  contractId?: InputMaybe<Scalars['UUID']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
};


export type QueryQuoteArgs = {
  contractId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
};


export type QueryRecentlyViewedItemsArgs = {
  dealerAccountId: Scalars['ID']['input'];
};


export type QuerySearchAddressArgs = {
  country: Scalars['String']['input'];
  search: Scalars['String']['input'];
};


export type QuerySearchDealerAccountsArgs = {
  searchKey: Scalars['String']['input'];
};


export type QuerySearchOrganizationsArgs = {
  searchRequest: OrganizationSearchRequestInput;
};


export type QuerySearchUsersByEmailIdArgs = {
  emailId: Scalars['String']['input'];
  iamAccountId: Scalars['String']['input'];
};


export type QueryShipToContactBulkDetailsArgs = {
  customerId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
};


export type QueryShipToContactBulkDetailsByIdArgs = {
  bulkOperationId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
};


export type QueryShipToContactIdsForCustomerArgs = {
  accountId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
};


export type QueryValidateAddOnBaseArgs = {
  input: ValidateAddOnBaseInput;
};


export type QueryValidateAddressArgs = {
  address: AddressInput;
};


export type QueryValidateContractProductsPricingArgs = {
  contractId: Scalars['ID']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  productIds: Array<Scalars['String']['input']>;
};


export type QueryValidateCustomerUserEmailArgs = {
  customerId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};


export type QueryValidateCustomerUserEmailsArgs = {
  customerId: Scalars['ID']['input'];
  dealerAccountId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
};

export type Quote = {
  __typename?: 'Quote';
  CreatedFromQuote?: Maybe<Quote>;
  adminComment?: Maybe<Scalars['String']['output']>;
  approvalRequestType?: Maybe<ApprovalRequestType>;
  approvalRequests: Array<ContractApprovalRequest>;
  approvalStatus?: Maybe<ApprovalStatus>;
  contract?: Maybe<Contract>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  createdUserRole?: Maybe<DealerUserRole>;
  currency: Currency;
  discount?: Maybe<Scalars['Decimal']['output']>;
  discounts: Array<QuoteDiscount>;
  fileId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['ID']['output'];
  isCancellationProcessed?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if repricing is required for this quote. */
  isRepriceRequired: Scalars['Boolean']['output'];
  lines: Array<QuoteLine>;
  /** Sum of line list prices including before tax and discounts. */
  listPriceSubtotal: Scalars['Decimal']['output'];
  /** Sum of line list prices after tax. */
  listPriceTotal: Scalars['Decimal']['output'];
  /** Sum of line net prices including discounts before tax. */
  netPriceSubtotal: Scalars['Decimal']['output'];
  /** Sum of line net prices after tax and discounts. */
  netPriceTotal: Scalars['Decimal']['output'];
  promoCode?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quoteNumber: Scalars['Int']['output'];
  quoteNumberSearch: Scalars['String']['output'];
  quoteType: QuoteType;
  startDate?: Maybe<Scalars['Date']['output']>;
  status: ContractStatusType;
  statusChangeReason?: Maybe<ContractStatusReason>;
  surchargeAmount: Scalars['Decimal']['output'];
  surchargePercent: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  validUntilDate?: Maybe<Scalars['Date']['output']>;
};

export const QuoteActionType = {
  AddProduct: 'ADD_PRODUCT',
  AddSeats: 'ADD_SEATS',
  CoTerm: 'CO_TERM',
  FullCancellation: 'FULL_CANCELLATION',
  FullDowngrade: 'FULL_DOWNGRADE',
  FullRenew: 'FULL_RENEW',
  FullUpgrade: 'FULL_UPGRADE',
  MultiYear: 'MULTI_YEAR',
  PartialCancellation: 'PARTIAL_CANCELLATION',
  PartialDowngrade: 'PARTIAL_DOWNGRADE',
  PartialRenew: 'PARTIAL_RENEW',
  PartialUpgrade: 'PARTIAL_UPGRADE'
} as const;

export type QuoteActionType = typeof QuoteActionType[keyof typeof QuoteActionType];
export type QuoteActionTypeOperationFilterInput = {
  eq?: InputMaybe<QuoteActionType>;
  in?: InputMaybe<Array<QuoteActionType>>;
  neq?: InputMaybe<QuoteActionType>;
  nin?: InputMaybe<Array<QuoteActionType>>;
};

export type QuoteDiscount = {
  __typename?: 'QuoteDiscount';
  amount: Scalars['Decimal']['output'];
  percent?: Maybe<Scalars['Decimal']['output']>;
  qualifyingQuantity?: Maybe<Scalars['Int']['output']>;
  quote?: Maybe<Quote>;
  quoteLine?: Maybe<QuoteLine>;
  type: DiscountType;
};

export type QuoteFilterInput = {
  adminComment?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<QuoteFilterInput>>;
  approvalRequestType?: InputMaybe<NullableOfApprovalRequestTypeOperationFilterInput>;
  approvalRequests?: InputMaybe<ListFilterInputTypeOfContractApprovalRequestFilterInput>;
  approvalStatus?: InputMaybe<NullableOfApprovalStatusOperationFilterInput>;
  createdBy?: InputMaybe<UuidOperationFilterInput>;
  createdUserRole?: InputMaybe<NullableOfDealerUserRoleOperationFilterInput>;
  discount?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<QuoteFilterInput>>;
  promoCode?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ContractStatusTypeOperationFilterInput>;
  statusChangeReason?: InputMaybe<NullableOfContractStatusReasonOperationFilterInput>;
  surchargeAmount?: InputMaybe<DecimalOperationFilterInput>;
  surchargePercent?: InputMaybe<DecimalOperationFilterInput>;
};

export type QuoteLine = {
  __typename?: 'QuoteLine';
  action: QuoteActionType;
  childProduct?: Maybe<Product>;
  devices: Array<DealerDevice>;
  discounts: Array<QuoteDiscount>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  isExternal: Scalars['Boolean']['output'];
  licenseBreakdown: LicenseBreakdown;
  listPrice: Scalars['Decimal']['output'];
  listPriceTotal: Scalars['Decimal']['output'];
  netPriceTotalPreTax: Scalars['Decimal']['output'];
  netPriceTotalWithTax: Scalars['Decimal']['output'];
  parentProduct?: Maybe<Product>;
  product: Product;
  quantity: Scalars['Int']['output'];
  quote: Quote;
  quoteLineDetails: Array<RenewalLine>;
  surchargeAmount: Scalars['Decimal']['output'];
  surchargePercent: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
};

export type QuoteSortInput = {
  adminComment?: InputMaybe<SortEnumType>;
  approvalRequestType?: InputMaybe<SortEnumType>;
  approvalStatus?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdUserRole?: InputMaybe<SortEnumType>;
  discount?: InputMaybe<SortEnumType>;
  promoCode?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusChangeReason?: InputMaybe<SortEnumType>;
  surchargeAmount?: InputMaybe<SortEnumType>;
  surchargePercent?: InputMaybe<SortEnumType>;
};

export const QuoteType = {
  Amendment: 'AMENDMENT',
  CoTerm: 'CO_TERM',
  InitialSale: 'INITIAL_SALE',
  MultiYear: 'MULTI_YEAR',
  Renewal: 'RENEWAL',
  Trial: 'TRIAL'
} as const;

export type QuoteType = typeof QuoteType[keyof typeof QuoteType];
export type QuoteTypeOperationFilterInput = {
  eq?: InputMaybe<QuoteType>;
  in?: InputMaybe<Array<QuoteType>>;
  neq?: InputMaybe<QuoteType>;
  nin?: InputMaybe<Array<QuoteType>>;
};

export type RecentActivityOutput = {
  __typename?: 'RecentActivityOutput';
  changes: Scalars['Int']['output'];
  discounts?: Maybe<Array<QuoteDiscount>>;
  externalQuoteId: Scalars['String']['output'];
  metric?: Maybe<ProductSkuMetric>;
  netPriceTotal: Scalars['Decimal']['output'];
  parentProductDescription?: Maybe<Scalars['String']['output']>;
  parentProductId?: Maybe<Scalars['String']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  quoteActionType: QuoteActionType;
  startDate?: Maybe<Scalars['Date']['output']>;
  subscriptionModelType: SubscriptionModelType;
};

export const RecentlyViewedEntityType = {
  Amendment: 'AMENDMENT',
  Contract: 'CONTRACT',
  Customer: 'CUSTOMER',
  Device: 'DEVICE'
} as const;

export type RecentlyViewedEntityType = typeof RecentlyViewedEntityType[keyof typeof RecentlyViewedEntityType];
export type RecentlyViewedItem = {
  __typename?: 'RecentlyViewedItem';
  contractId?: Maybe<Scalars['ID']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  dealerAccountId: Scalars['ID']['output'];
  entityType: RecentlyViewedEntityType;
  iamDeviceId?: Maybe<Scalars['ID']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['ID']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  viewedAt: Scalars['DateTime']['output'];
};

export type RecordRecentlyViewedItemInput = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dealerAccountId: Scalars['ID']['input'];
  entityType: RecentlyViewedEntityType;
  iamDeviceId?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Region = {
  __typename?: 'Region';
  code: Scalars['String']['output'];
  defaultName: Scalars['String']['output'];
};

export type RemoveProductLineAmendmentInput = {
  currentProductId: Scalars['ID']['input'];
  entitlementId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<SkuKind>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type RemoveSeatsLineAmendmentInput = {
  currentProductId: Scalars['ID']['input'];
  entitlementId?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<SkuKind>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type RenewalLine = {
  __typename?: 'RenewalLine';
  entitlementId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  licenseId?: Maybe<Array<Scalars['String']['output']>>;
  lineNumber: Scalars['String']['output'];
  metaCreatedDateTime: Scalars['DateTime']['output'];
  metaUpdatedDateTime?: Maybe<Scalars['DateTime']['output']>;
  parentLineNumber?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  quoteLine?: Maybe<QuoteLine>;
  quoteLineId?: Maybe<Scalars['Long']['output']>;
  sfRecordId: Scalars['String']['output'];
  type: ContractRenewalLineType;
};

export const RepriceActionType = {
  BillingFrequencyChange: 'BILLING_FREQUENCY_CHANGE',
  DiscountChange: 'DISCOUNT_CHANGE',
  NoReprice: 'NO_REPRICE',
  PromoCodeChange: 'PROMO_CODE_CHANGE',
  Reprice: 'REPRICE',
  TermuomChange: 'TERMUOM_CHANGE',
  WithdrawBillingFrequencyChange: 'WITHDRAW_BILLING_FREQUENCY_CHANGE',
  WithdrawDiscountChange: 'WITHDRAW_DISCOUNT_CHANGE'
} as const;

export type RepriceActionType = typeof RepriceActionType[keyof typeof RepriceActionType];
export type RepriceContractInput = {
  billingFrequency?: InputMaybe<BillingFrequency>;
  contractId: Scalars['ID']['input'];
  discountPercentage?: InputMaybe<Scalars['Decimal']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quoteId: Scalars['ID']['input'];
  repriceActionType: RepriceActionType;
  userComment?: InputMaybe<Scalars['String']['input']>;
};

export type RequestProductPricelistInput = {
  countryCode: Scalars['String']['input'];
};

/** A device the dealer has asked its owner to transfer. Listed until the request is approved, declined, cancelled or expires. */
export type RequestedDevice = DealerDeviceCommon & {
  __typename?: 'RequestedDevice';
  dealerNote?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType: DeviceType;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modelName?: Maybe<Scalars['String']['output']>;
  partNumber: Scalars['String']['output'];
  requestExpiresAt: Scalars['DateTime']['output'];
  serialNumber: Scalars['String']['output'];
};

export type RestoreDefaultRequestInput = {
  customerAccountId?: InputMaybe<Scalars['String']['input']>;
  notificationChannel: NotificationChannel;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ResultQuality = {
  __typename?: 'ResultQuality';
  code: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type RevokeSubscriptionResponse = {
  __typename?: 'RevokeSubscriptionResponse';
  contractLine: ContractLine;
  device: DealerDevice;
};

export type RevokeUserSubscriptionResponse = {
  __typename?: 'RevokeUserSubscriptionResponse';
  contractLine: ContractLine;
  user: User;
};

export type SaveBulkUserEventPreferencesRequestInput = {
  preferences: Array<EventIgnoreItemInput>;
  userIds: Array<Scalars['UUID']['input']>;
};

export type SaveCategoryPreferenceRequestInput = {
  category: NotificationEventCategory;
  customerAccountId?: InputMaybe<Scalars['String']['input']>;
  ignoreNotification: Scalars['Boolean']['input'];
  notificationChannel: NotificationChannel;
  updatedBy?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SaveChannelPreferenceRequestInput = {
  customerAccountId?: InputMaybe<Scalars['String']['input']>;
  ignoreNotification: Scalars['Boolean']['input'];
  notificationChannel: NotificationChannel;
  updatedBy?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SaveCustomerDefaultsInput = {
  shipToAddressId?: InputMaybe<Scalars['ID']['input']>;
  shipToContactId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDealerAccountDefaultsInput = {
  billToAddressId?: InputMaybe<Scalars['ID']['input']>;
  billToContactId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveEventPreferenceRequestInput = {
  customerAccountId?: InputMaybe<Scalars['String']['input']>;
  eventType: NotificationEvent;
  ignoreNotification: Scalars['Boolean']['input'];
  notificationChannel: NotificationChannel;
  updatedBy?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ShipToContactBulkDetails = {
  __typename?: 'ShipToContactBulkDetails';
  bulkOperationId?: Maybe<Scalars['ID']['output']>;
  failedContractIds: Array<Scalars['ID']['output']>;
  newShipToContactId?: Maybe<Scalars['ID']['output']>;
  oldShipToContactId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<BulkOperationStatus>;
  successContractIds: Array<Scalars['ID']['output']>;
};

export const SkuKind = {
  Bundle: 'BUNDLE',
  Child: 'CHILD',
  Package: 'PACKAGE',
  Standard: 'STANDARD'
} as const;

export type SkuKind = typeof SkuKind[keyof typeof SkuKind];
export type SkuType = {
  __typename?: 'SkuType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SkuWarningItem = {
  __typename?: 'SkuWarningItem';
  description: Scalars['String']['output'];
  skuId: Scalars['String']['output'];
};

export const SortEnumType = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type SortEnumType = typeof SortEnumType[keyof typeof SortEnumType];
export type StartContractRenewalInput = {
  contractId: Scalars['ID']['input'];
};

export type StartContractRenewalPayload = {
  __typename?: 'StartContractRenewalPayload';
  startContractRenewalResult?: Maybe<StartContractRenewalResult>;
};

export type StartContractRenewalResult = {
  __typename?: 'StartContractRenewalResult';
  isSuccess: Scalars['Boolean']['output'];
  pendingAmendmentQuoteId?: Maybe<Scalars['String']['output']>;
  pendingCustomerRequestId?: Maybe<Array<Scalars['String']['output']>>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  contractStatusChanged: ContractStatusChanged;
  dashboardEventChanged: DashboardEventMessage;
  deviceExportChanged: DeviceExportUnion;
  deviceSyncStatusChanged: DeviceSyncStatus;
  notificationReceived: Notification;
};


export type SubscriptionContractStatusChangedArgs = {
  accountId: Scalars['ID']['input'];
};


export type SubscriptionDashboardEventChangedArgs = {
  accountId: Scalars['String']['input'];
};


export type SubscriptionDeviceExportChangedArgs = {
  requestId: Scalars['ID']['input'];
};


export type SubscriptionDeviceSyncStatusChangedArgs = {
  dealerAccountId: Scalars['ID']['input'];
};


export type SubscriptionNotificationReceivedArgs = {
  accountId: Scalars['ID']['input'];
};

export const SubscriptionModelType = {
  AccountBased: 'ACCOUNT_BASED',
  SeatBased: 'SEAT_BASED'
} as const;

export type SubscriptionModelType = typeof SubscriptionModelType[keyof typeof SubscriptionModelType];
export type SubscriptionResponse = {
  __typename?: 'SubscriptionResponse';
  subscriptions: Array<CustomerSubscription>;
};

export const SubscriptionTarget = {
  Device: 'DEVICE',
  User: 'USER'
} as const;

export type SubscriptionTarget = typeof SubscriptionTarget[keyof typeof SubscriptionTarget];
export type SuperKeyLine = {
  __typename?: 'SuperKeyLine';
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  product: Product;
};

export type SuperKeyProduct = {
  __typename?: 'SuperKeyProduct';
  product: Product;
};

export type SuperKeyResponse = {
  __typename?: 'SuperKeyResponse';
  superKeyProducts: Array<SuperKeyProduct>;
};

export type SuperkeyAuditDetails = DeviceAuditDetails & {
  __typename?: 'SuperkeyAuditDetails';
  device: DeviceAuditSnapshot;
  skus?: Maybe<Array<Scalars['String']['output']>>;
  superKeyId?: Maybe<Scalars['String']['output']>;
};

export type SuperkeyCount = {
  __typename?: 'SuperkeyCount';
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type SuperkeySkuRequestInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type SupportAdminRequestInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  otherReasonText?: InputMaybe<Scalars['String']['input']>;
  reasons: Array<SupportReason>;
  targetAccountId: Scalars['String']['input'];
  targetRoleId?: InputMaybe<DealerUserRole>;
  targetUserId: Scalars['String']['input'];
  viewType: SupportViewType;
};

export const SupportReason = {
  AccessIssue: 'ACCESS_ISSUE',
  All: 'ALL',
  ContractStatusIssue: 'CONTRACT_STATUS_ISSUE',
  CreateAmendment: 'CREATE_AMENDMENT',
  CreateContract: 'CREATE_CONTRACT',
  CustomerIssue: 'CUSTOMER_ISSUE',
  DeviceIssue: 'DEVICE_ISSUE',
  ErrorMessage: 'ERROR_MESSAGE',
  HowToGuidance: 'HOW_TO_GUIDANCE',
  InvoicingIssue: 'INVOICING_ISSUE',
  Other: 'OTHER',
  ReviewAmendment: 'REVIEW_AMENDMENT',
  ReviewContract: 'REVIEW_CONTRACT',
  ViewAmendmentStatus: 'VIEW_AMENDMENT_STATUS',
  ViewContractStatus: 'VIEW_CONTRACT_STATUS'
} as const;

export type SupportReason = typeof SupportReason[keyof typeof SupportReason];
export const SupportViewType = {
  Role: 'ROLE',
  User: 'USER'
} as const;

export type SupportViewType = typeof SupportViewType[keyof typeof SupportViewType];
export const TermUomType = {
  Month: 'MONTH',
  Onetime: 'ONETIME',
  Trial: 'TRIAL',
  Year: 'YEAR'
} as const;

export type TermUomType = typeof TermUomType[keyof typeof TermUomType];
export type TransferOptionsInput = {
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TrialEligibilityResponse = {
  __typename?: 'TrialEligibilityResponse';
  accountId: Scalars['String']['output'];
  existingTrialCount: Scalars['Int']['output'];
  isEligible: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  skuId: Scalars['String']['output'];
};

export const UiFeatureFlagNames = {
  AccountStorage: 'ACCOUNT_STORAGE',
  AddDevice: 'ADD_DEVICE',
  BundlePackageLicenseAssignments: 'BUNDLE_PACKAGE_LICENSE_ASSIGNMENTS',
  CdhidIamidMigration: 'CDHID_IAMID_MIGRATION',
  ContractInvoiceTab: 'CONTRACT_INVOICE_TAB',
  ContractLicenseAssignmentEnhancements: 'CONTRACT_LICENSE_ASSIGNMENT_ENHANCEMENTS',
  ContractVersioning: 'CONTRACT_VERSIONING',
  CurrencyPicker: 'CURRENCY_PICKER',
  CustomerAssistant: 'CUSTOMER_ASSISTANT',
  CustomerEmailSetting: 'CUSTOMER_EMAIL_SETTING',
  CustomerPage: 'CUSTOMER_PAGE',
  DashboardEnhancement: 'DASHBOARD_ENHANCEMENT',
  DealerPage: 'DEALER_PAGE',
  DebugMenu: 'DEBUG_MENU',
  DeviceList: 'DEVICE_LIST',
  DeviceListEnhancements: 'DEVICE_LIST_ENHANCEMENTS',
  DeviceListSync: 'DEVICE_LIST_SYNC',
  DeviceTransferBackToDealerNotification: 'DEVICE_TRANSFER_BACK_TO_DEALER_NOTIFICATION',
  ExportPriceList: 'EXPORT_PRICE_LIST',
  IdleTimeout: 'IDLE_TIMEOUT',
  InvoiceModuleCreditMemo: 'INVOICE_MODULE_CREDIT_MEMO',
  LockRate: 'LOCK_RATE',
  MachineTranslationPreview: 'MACHINE_TRANSLATION_PREVIEW',
  NotificationSnackbarDesign: 'NOTIFICATION_SNACKBAR_DESIGN',
  PackagesMidterm: 'PACKAGES_MIDTERM',
  RecentlyViewed: 'RECENTLY_VIEWED',
  SelfOrder: 'SELF_ORDER',
  SideNavigation: 'SIDE_NAVIGATION',
  SideSheet: 'SIDE_SHEET',
  UserSubscriptions: 'USER_SUBSCRIPTIONS',
  UxUpdate: 'UX_UPDATE',
  VwCustomerLink: 'VW_CUSTOMER_LINK',
  VwCustomerLinkFailure: 'VW_CUSTOMER_LINK_FAILURE',
  VwDeviceLicenseChecks: 'VW_DEVICE_LICENSE_CHECKS'
} as const;

export type UiFeatureFlagNames = typeof UiFeatureFlagNames[keyof typeof UiFeatureFlagNames];
export type UpdateCustomerUsersInput = {
  customerUserEmails: Array<Scalars['String']['input']>;
  previousRole?: InputMaybe<UserRole>;
  userRole: UserRole;
};

export type UpgradeLineAmendmentInput = {
  currentProductId: Scalars['ID']['input'];
  entitlementId?: InputMaybe<Scalars['String']['input']>;
  licenseSelection?: InputMaybe<Array<LicenseSelectionInput>>;
  licenseSelectionType?: InputMaybe<LicenseSelectionType>;
  newProductId: Scalars['ID']['input'];
  productType?: InputMaybe<SkuKind>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  iamAccountId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  productLines: Array<ProductLineUnion>;
  role: UserRole;
  roles: Array<UserRole>;
  status: UserStatus;
};

export type UserAuditItem = {
  __typename?: 'UserAuditItem';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
};

export const UserNotificationStatus = {
  Deleted: 'DELETED',
  Read: 'READ',
  Unread: 'UNREAD'
} as const;

export type UserNotificationStatus = typeof UserNotificationStatus[keyof typeof UserNotificationStatus];
export type UserNotificationStatusOperationFilterInput = {
  eq?: InputMaybe<UserNotificationStatus>;
  in?: InputMaybe<Array<UserNotificationStatus>>;
  neq?: InputMaybe<UserNotificationStatus>;
  nin?: InputMaybe<Array<UserNotificationStatus>>;
};

export const UserRole = {
  Admin: 'ADMIN',
  Contact: 'CONTACT',
  Owner: 'OWNER',
  ProductUser: 'PRODUCT_USER',
  SecondaryOwner: 'SECONDARY_OWNER',
  SupportAdmin: 'SUPPORT_ADMIN'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];
export type UserRoleOperationFilterInput = {
  eq?: InputMaybe<UserRole>;
  in?: InputMaybe<Array<UserRole>>;
  neq?: InputMaybe<UserRole>;
  nin?: InputMaybe<Array<UserRole>>;
};

export const UserStatus = {
  Committed: 'COMMITTED',
  Expired: 'EXPIRED',
  Failed: 'FAILED',
  Pending: 'PENDING'
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];
export type UserStatusOperationFilterInput = {
  eq?: InputMaybe<UserStatus>;
  in?: InputMaybe<Array<UserStatus>>;
  neq?: InputMaybe<UserStatus>;
  nin?: InputMaybe<Array<UserStatus>>;
};

export type UserUnion = PendingUser | User;

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserUnion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserUnion;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input for validating add-on / base product pairings in the current transaction. */
export type ValidateAddOnBaseInput = {
  /** Existing contract ID. Pass only when amending an existing contract so the backend can compare against current contract lines. */
  contractId?: InputMaybe<Scalars['String']['input']>;
  /** All selected SKUs in the current transaction - pass both add-on and base product SKUs. */
  newSku?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Base product SKUs being removed - used for the negative amendment (remove) case. */
  removedSku?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ValidateContractProductsPricingResult = {
  __typename?: 'ValidateContractProductsPricingResult';
  invalidProductIds: Array<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
};

export type ValidatedAddress = {
  __typename?: 'ValidatedAddress';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  countryDetails: CountryDetails;
  matchPercentage: Scalars['Decimal']['output'];
  resultQuality: ResultQuality;
  stateDetails?: Maybe<Region>;
  zip: Scalars['String']['output'];
};

/**
 * Result of the warmUpSession mutation: a correlation id for the login warm-up and the
 * dealer account ids for which a background sync was (or already had been) started. The UI uses
 * the ids to open per-dealer deviceSyncStatusChanged subscriptions.
 */
export type WarmUpSessionResult = {
  __typename?: 'WarmUpSessionResult';
  dealerAccountIds: Array<Scalars['ID']['output']>;
  sessionId: Scalars['ID']['output'];
};

/**
 * Input for withdrawing an approval request for a contract.
 * Supports different withdrawal types: Billing Frequency, Discount, or Promocode.
 */
export type WithdrawApprovalInput = {
  approvalRequestId: Scalars['Int']['input'];
  contractId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
  withdrawalType: ApprovalWithdrawalType;
};
